<style lang="stylus">

    .scene
        position absolute
        top 105px
        left 0px
        right 40px
        bottom 35px
        overflow scroll
        &::-webkit-scrollbar {
            height: 6px;
            width: 6px;
            background-color: transparent;
            pointer-events: none;
        }
        > canvas {
            will-change: transform;
            transform: translateZ(0);
        }
        // scrollbar-width thin
        // &::-webkit-scrollbar
        //     width 12px
        //     height 12px
        // &::-webkit-scrollbar-thumb
        //     width 8px
        //     height 8px
        //     border-radius 6.5px
        //     background #E2E2E7
        //     border 2px solid #FEFEFF
        // &::-webkit-scrollbar-track
        //     width 12px
        //     height 12px
        //     background #FEFEFF
        .flowBtnClass
            // fill rgba(210,210,210,0.8)
            fill var(--themeColor);
            &.active
                // fill rgb(1, 127, 255)
                fill (--themeColor);
            &:hover
                // fill rgb(1, 127, 255)
                fill (--themeColor);
        .floatBtnClass
            fill none
            cursor default
            &:hover
                fill rgba(210,210,210,0.8)
        .echart-list
            position fixed
            width 100%
            height 100%
            z-index 2
            pointer-events none
            overflow hidden
    .teams-scene
        &::-webkit-scrollbar
            display none
    .sdk-scene
        &::-webkit-scrollbar {
            width: 8px;
            display: block;
        }
        &::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.08);
            border-radius: 12px;
            box-shadow: none;
            margin: 2px 1px;
            cursor: pointer;

            border-radius: 10px;
            border-style: dashed;
            border-color: transparent;
            border-width: 2px;
            background-clip: padding-box;

            &:hover {
            background: rgba(0, 0, 0, 0.2);
            }
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
            box-shadow: none;
        }


    .selectLibrary
        left 250px

    .group-scene
        left 0 !important
        top 0 !important
        right 0 !important
        bottom 35px !important

    .selectEChart
        left -450px
        right 450px

    .floatMenu-box
        position absolute
        pointer-events none
        .floatMenu
            pointer-events: auto
        .optionMenu
            pointer-events: auto

    .filenumlimit-tips
        position fixed
        left 50%
        top 16px
        display flex
        align-items center
        height 32px
        width 580px
        max-width 100%
        padding 0 16px
        background linear-gradient(267.65deg, #FFDBA6 9.41%, #FFF5C6 90.77%)
        border-radius 32px
        transform translateX(-50%)
        z-index 1001
        cursor pointer
        user-select none
        @media screen and (max-width: 1250px)
            width 480px
        @media screen and (max-width: 970px)
            width 300px
        &:hover
            background linear-gradient(267.65deg, #FFCD83 9.41%, #FFEBA6 90.77%)
        svg
            width 16px
            height 16px
            margin-right 8px
        p
            color #4B2603
            font-size 14px
            line-height 16px
            textOverflow()
</style>

<template>
    <div
        id="scene"
        class="scene"
        ref="scene"
        :class="{ 'group-scene': isPreviewView, 'teams-scene': isTeamsApp, 'sdk-scene': isSdk }"
        @dragover="fileDragOver($event)"
        @click="setActive"
        @drop="fileDrop($event)"
    >
        <canvas class="bgcanvas" id="bgcanvas" ref="bgcanvas"></canvas>
        <canvas class="mycanvas" id="mycanvas" ref="canvas"></canvas>
        <canvas class="animationcanvas" id="animationcanvas" ref="animationcanvas"></canvas>
        <svg id="opesvg" ref="opesvg"></svg>

        <div class="filenumlimit-tips" v-if="isFileLimitTip" @click="toVip()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_i_11150_300561)">
                    <path
                        d="M12.4821 1H3.51788C2.99698 1 2.52159 1.29675 2.29281 1.76471L0.389092 5.65868C0.152471 6.14267 0.222985 6.72061 0.569037 7.13351L6.95488 14.753C7.49989 15.4033 8.50011 15.4033 9.04512 14.753L15.431 7.13351C15.777 6.72061 15.8475 6.14267 15.6109 5.65868L13.7072 1.76471C13.4784 1.29675 13.003 1 12.4821 1Z"
                        fill="url(#paint0_linear_11150_300561)"
                    />
                </g>
                <path
                    d="M4.5 7H5.5L8 10.5L10.5 7H11.5"
                    stroke="white"
                    stroke-opacity="0.8"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_i_11150_300561"
                        x="0.25"
                        y="1"
                        width="15.5"
                        height="15.7422"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="1.5" />
                        <feGaussianBlur stdDeviation="1" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.898667 0 0 0 0 0.366667 0 0 0 0.3 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_11150_300561" />
                    </filter>
                    <linearGradient id="paint0_linear_11150_300561" x1="2.5" y1="1" x2="13.7929" y2="14.2504" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FFDE54" />
                        <stop offset="1" stop-color="#FF9300" />
                    </linearGradient>
                </defs>
            </svg>
            <p
                v-html="$t('filenumlimitTips', { fileNum: limitFileNum })"
                :title="$t('filenumlimitTips', { fileNum: limitFileNum }).replace(/\<.[^\>]*\>/g, '')"
            ></p>
        </div>

        <ColorSucker v-if="showColorSucker" v-show="inScene" />
        <div id="floatgroup" ref="floatgroup"></div>
        <div id="context" ref="context"></div>
        <editSet ref="editset" />

        <div id="floatMenuBox" class="floatMenu-box" :style="{ width: `${svgWidth}px`, height: `${svgHeight}px` }">
            <!-- <FloatMenu class="floatMenu" :key="activeFloatMenu.id" v-if="!!activeFloatMenu" :itemID="activeFloatMenu.id" /> -->
            <FloatMenu
                v-for="(item, index) in floatMenuList"
                class="floatMenu"
                :key="item.id"
                :itemID="item.id"
                :item="item"
                :style="{ 'z-index': activeHoverFloatID == item.id ? 2 : 1 }"
            />
            <FloatOption
                class="optionMenu"
                v-show="smallscreen && activeFloatOption == index"
                v-for="(item, index) in floatOptionList"
                :key="'option' + item.id"
                :itemID="item.id"
                :style="{ 'z-index': activeFloatOption == index ? 2 : 1 }"
            ></FloatOption>
        </div>
        <AICreateOutside v-if="showAICreate" :aiType="aiType" :aiKeys="aiKeys" @aiCreateDone="closeAICreate" />
        <Remark :width="svgWidth" :height="svgHeight" />

        <div ref="echartListRef" @wheel="onWheelEchartList" class="echart-list">
            <EchartBox v-for="item in echartList" :chartInfo="item" :key="item ? item.itemId : ''" :offset="echartListOffset" />
        </div>
    </div>
</template>

<script lang="ts">
    // @ts-nocheck
    declare var EDView: any;
    declare var EDDocument: any;
    declare var ThemeManager: any;
    declare var AutoSaveTimer: any;
    declare var ForceSaveTimer: any;
    declare var saveAs: any;
    declare var echarts: any;
    declare var $edAuth: any;
    declare var LocalizeUtil: any;
    declare var CreateNewFile: any;
    import ColorSucker from "./Common/Color/ColorSucker.vue";
    import appConfig from "@/public/globalConfig";
    import editSet from "./EditSet.vue";
    import FloatMenu from "./Modals/FloatMenu.vue";
    import FloatOption from "./Modals/FloatOption.vue";
    import AICreateOutside from "./AICreateOutside.vue";
    import Remark from "./Remark.vue";
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
    import { Dropbox } from "dropbox";
    import googleApi from "../utils/googleApi.js";
    import { validate, refreshToken } from "@/public/utils/auth";
    import { EDRAWMAX_USE_CUSTOMLIBRARY, EDRAWMAX_WXREDIRECT } from "@/env/";
    import axios from "axios";
    import { urls } from "@/public/utils/env.js";
    import { getQueryString, getHashString } from "@/public/utils/tool";
    import { ValidLang, LangKeys } from "../utils/constant";
    import shape from "../store/modules/shape";
    import EchartBox from "@/app/components/thirdpart/EchartBox.vue";
    import { checkAccessKey } from "@/app/utils/sdkAccess.js";
    import { getSdkSaveData } from "@/public/utils/tool";
    import throttle from "lodash/throttle";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            editSet,
            ColorSucker,
            FloatMenu,
            FloatOption,
            AICreateOutside,
            Remark,
            EchartBox,
        },
    })
    export default class MyComponent extends Vue {
        timer: number = 0;
        workerURL: string = appConfig.workerURL;
        userWorkerURL: string = appConfig.userWorkerURL;
        libraryWorkerURL: string = appConfig.libraryWorkerURL;
        libFlag: boolean = false;
        libVersionObj: any;
        smallscreen: boolean = false;

        backupUserInfo: any;
        resizeFlag: boolean = false;
        quickShapeData: object;
        aiDrawData: object;
        openClassID = null;

        openLibraryID: number = 0; // 符号模板在自定义库的tableID
        openLibraryWorkID: number = 0; // 符号模板的模板id

        showAICreate = false; // 外部创建ai指令
        aiType = "";
        aiKeys = "";

        urlData = "";

        loading = false;

        get showColorSucker() {
            return this.$store.state.ui.showColorSucker;
        }
        get inScene() {
            return this.$store.state.ui.inScene;
        }
        get sceneRight() {
            if (!this.focusModeExpandRight) return 0;
            if (this.$store.state.ui.showRightPanel) return this.$store.state.ui.sceneRight + "px";
            else return "50px";
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft + "px";
        }
        get focusModeExpandRight() {
            return this.$store.getters.expandRight;
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }

        // 禁止浏览器默认事件
        fileDragOver(e) {
            e.preventDefault();
        }
        // 拖拽上传图片
        fileDrop(e) {
            e.stopPropagation();
            e.preventDefault();
            let files = e.dataTransfer.files;
            e.target.style.backgroundColor = "transparent";
            if (files.length > 0) {
                let view = window["_view"];
                if (!view) return;
                view.insertImageFromFile(files);
            }
        }
        setMenuFunc(extraShowArr = [], extraArr = [], noInit = false) {
            let isNewMenu = this.libFlag;
            let versionObj = this.libVersionObj;
            let extraDB = this.$store.state.library.extraDB;
            let userID = this.$store.state.user.userInfo && this.$store.state.user.userInfo.user_id;
            // extraDB[0] = extraDB[0] == "userDB" ? `${extraDB[0]}_${userID}` : extraDB[0];
            // extraDB[1] = extraDB[1] == "openDB" ? `${extraDB[1]}_${userID}` : extraDB[1];
            extraDB[2] = extraDB[2] == "myDB" ? `${extraDB[2]}_${userID}` : extraDB[2];
            let saveLocalMenu = (data) => {
                let DBName = "menuDB";
                let opendb = indexedDB.open(DBName);
                opendb.onupgradeneeded = (e) => {
                    let db = opendb.result;
                    let obj = db.objectStoreNames;
                    db.createObjectStore("groupName", { keyPath: "index" });
                };
                opendb.onsuccess = (e) => {
                    let db = opendb.result;
                    let trans = db.transaction("groupName", "readwrite");
                    let objstore = trans.objectStore("groupName");

                    let action = objstore.put({
                        index: 1,
                        data: data,
                    });

                    trans.oncomplete = () => {
                        db.close();
                        let opendb = indexedDB.open("versionDB");
                        opendb.onsuccess = (e) => {
                            let db = opendb.result;
                            let trans = db.transaction("configVersion", "readwrite");
                            let objstore = trans.objectStore("configVersion");

                            let index = objstore.index("configIDIndex");
                            index.get(versionObj["configID"]).onsuccess = (e) => {
                                // 通过索引查找原数据，如有则覆盖
                                let data = (e.target as IDBRequest).result;
                                if (data) {
                                    versionObj.index = data.index;
                                    objstore.put(versionObj);
                                } else {
                                    let cursorData = [];
                                    let request = objstore.openCursor();
                                    request.onsuccess = (e) => {
                                        let cursor = (e.target as IDBRequest).result;
                                        if (cursor) {
                                            cursorData.push(cursor.value);
                                            cursor.continue();
                                        } else {
                                            let result = cursorData;
                                            let index = 0;
                                            for (let i = 0; i < result.length; i++) {
                                                index = result[i].index > index ? result[i].index : index;
                                            }
                                            versionObj.index = index + 1;
                                            objstore.put(versionObj);

                                            trans.oncomplete = () => {
                                                db.close();
                                            };
                                        }
                                    };
                                }
                            };
                        };
                    };
                };
            };
            let getLocalMenu = () => {
                let DBName = "menuDB";
                let tableName = "groupName";
                let opendb = indexedDB.open(DBName);
                return new Promise((res, rej) => {
                    opendb.onsuccess = (e) => {
                        let db = opendb.result;
                        let trans = db.transaction(tableName, "readwrite");
                        let objstore = trans.objectStore(tableName);

                        let getRequest = objstore.get(1);
                        getRequest.onsuccess = () => {
                            let result = getRequest.result;
                            res(result);
                            db.close();
                        };
                    };
                });
            };
            let loadMenu = (data) => {
                // 整理公共库格式，连接自定义库和打开库
                let lib = data.lib;
                let groupName = Object.keys(lib);
                let menuArr = [];
                let showArr = [];
                let checkbox = {};
                for (let i of groupName) {
                    if (!window.EDCONFIG.A_LI_CLOUD_AND_TENCENT_CLOUD_LIBRARY_ENABLE) {
                        if (i === "Alibaba Cloud" || i === "Tencent Cloud") {
                            continue;
                        }
                    }
                    let obj = {
                        id: lib[i]["attr"].id,
                        groupName: lib[i]["attr"].name,
                        description: lib[i]["attr"].description,
                        groupName_zh: lib[i]["attr"].name_zh,
                        groupName_de: lib[i]["attr"].name_de,
                        // groupName_en: lib[i]['attr'].name_en,
                        groupName_es: lib[i]["attr"].name_es,
                        groupName_fr: lib[i]["attr"].name_fr,
                        groupName_jp: lib[i]["attr"].name_jp,
                        groupName_ru: lib[i]["attr"].name_ru,
                        groupName_it: lib[i]["attr"].name_it,
                        groupName_pt: lib[i]["attr"].name_pt,
                        groupName_tw: lib[i]["attr"].name_tw,
                        groupName_kr: lib[i]["attr"].name_kr,
                        description_zh: lib[i]["attr"].desc_zh,
                        description_de: lib[i]["attr"].desc_de,
                        description_en: lib[i]["attr"].desc_en,
                        description_es: lib[i]["attr"].desc_es,
                        description_fr: lib[i]["attr"].desc_fr,
                        description_jp: lib[i]["attr"].desc_jp,
                        description_ru: lib[i]["attr"].desc_ru,
                        description_it: lib[i]["attr"].desc_it,
                        description_pt: lib[i]["attr"].desc_pt,
                        description_tw: lib[i]["attr"].desc_tw,
                        description_kr: lib[i]["attr"].desc_kr,
                        desc_image: lib[i]["attr"].desc_image,
                        show: false,
                        indeterminate: false,
                        checkedAll: false,
                        checkedList: [],
                        children: lib[i]["children"].map((v, k) => {
                            return {
                                id: v.id,
                                tableName: v.name,
                                tableName_zh: v.zh,
                                tableName_de: v.de,
                                tableName_en: v.en,
                                tableName_es: v.es,
                                tableName_fr: v.fr,
                                tableName_jp: v.jp,
                                tableName_ru: v.ru,
                                tableName_it: v.it,
                                tableName_pt: v.pt,
                                tableName_tw: v.tw,
                                tableName_kr: v.kr,
                                version: v.version,
                                type: v.type,
                                mcount: v.mcount,
                                url: `${data.host}/${v.url}`,
                                checked: false,
                            };
                        }),
                    };
                    let showObj = {
                        groupName: lib[i]["attr"].name,
                        children: lib[i]["children"].map((v, k) => {
                            return {
                                tableName: v.name,
                                showList: [],
                            };
                        }),
                    };
                    checkbox[i] = [];
                    menuArr.push(obj);
                    showArr.push(showObj);
                }
                showArr = extraShowArr.concat(showArr);
                menuArr = extraArr.concat(menuArr); // 将特殊库连接到菜单目录
                checkbox[extraDB[2]] = [];

                this.$store.commit("setLibraryState", {
                    type: "displayList",
                    data: showArr,
                });
                this.$store.commit("setLibraryState", {
                    type: "menuList",
                    data: menuArr,
                });
                if (!noInit) {
                    this.$store.commit("setLibraryState", {
                        type: "checkbox",
                        data: checkbox,
                    });
                }
            };
            return new Promise((rs, rj) => {
                let localAppVersion = JSON.parse(localStorage.getItem("appVersion"));
                if (!localAppVersion) {
                    localStorage.setItem("appVersion", JSON.stringify(this.appVersion));
                    // 更新了符号库数据 menuArr 新增图片 desc_image 字段，要强制请求数据一次
                }
                if (isNewMenu || !localAppVersion) {
                    this.$edApi.getAllLibInfo().then((res) => {
                        let data = res;
                        saveLocalMenu(res);
                        loadMenu(data);
                        rs();
                    });
                } else {
                    getLocalMenu().then((e) => {
                        // 加载本地数据，生成符号库菜单
                        loadMenu(e["data"]);
                        rs();
                    });
                }
            });
        }
        getLibraryList(noInit = false) {
            // 获取符号库菜单, true 使用在线数据并更新本地，false 使用本地数据

            let extraDB = this.$store.state.library.extraDB;
            let userID = this.$store.state.user.userInfo && this.$store.state.user.userInfo.user_id;
            extraDB[0] = extraDB[0] == "userDB" ? `${extraDB[0]}_${userID}` : extraDB[0];
            extraDB[1] = extraDB[1] == "openDB" ? `${extraDB[1]}_${userID}` : extraDB[1];
            extraDB[2] = extraDB[2] == "myDB" ? `${extraDB[2]}_${userID}` : extraDB[2];
            let myDB = extraDB[2];

            let extraArr = [];
            let extraShowArr = [];

            const getExtraDB = () => {
                // 获取特殊库
                if (!EDRAWMAX_USE_CUSTOMLIBRARY || this.noLoginEditor || !window.EDCONFIG.MY_LIBRARY_ENABLE) return Promise.resolve();
                let checkMyDB = () => {
                    // 从云服务器同步收藏库及自定义库
                    let userInfo = this.$store.state.user.userInfo;
                    let DBName = myDB;
                    let onlineList = [],
                        localList = [],
                        promiseList = [],
                        downloadList = [],
                        deleteList = [];
                    let getCollect = () => {
                        return new Promise((rs, rj) => {
                            this.$edApi
                                .getCustomLibraryList({
                                    id: userInfo.user_id,
                                    token: userInfo.token,
                                    type: 1,
                                })
                                .then((e) => {
                                    if (e.data.length == 0) {
                                        let worker = new Worker(this.userWorkerURL);
                                        worker.postMessage({
                                            type: "new",
                                            urls: this.urls,
                                            data: {
                                                DBName: DBName,
                                                tableName: "collect",
                                                versionDB: `myDBVersion_${userInfo.user_id}`,
                                                userInfo: {
                                                    id: userInfo.user_id,
                                                    token: userInfo.token,
                                                },
                                                libType: 1,
                                            },
                                        });
                                        worker.onmessage = (e) => {
                                            let message = e.data;
                                            if (message.type === "newOK") {
                                                worker.terminate();
                                                this.$bus.$asyncEmit("uploadToCloud", { message });
                                                rs();
                                            } else if (message.type == "error" && message.msg == "name repeated") {
                                                worker.terminate();
                                                rs();
                                            }
                                        };
                                    } else {
                                        this.$store.commit("setLibraryState", {
                                            type: "collectTBEdtKey",
                                            data: e.msg + e.data[0].ucode + ".edt",
                                        });
                                        onlineList = onlineList.concat(
                                            e.data.map((v, k) => {
                                                v["url"] = e.msg + v.ucode;
                                                if (this.isPrivate) {
                                                    v["key"] = v.symbol_key;
                                                    this.$store.commit("setLibraryState", {
                                                        type: "collectTBSymbolKey",
                                                        data: v.symbol_key,
                                                    });
                                                }
                                                return v;
                                            })
                                        );
                                        rs();
                                    }
                                });
                        });
                    };
                    let getCustom = () => {
                        return new Promise((rs, rj) => {
                            this.$edApi
                                .getCustomLibraryList({
                                    id: userInfo.user_id,
                                    token: userInfo.token,
                                    type: 0,
                                })
                                .then((e) => {
                                    this.$store.commit("setLibraryState", {
                                        type: "ossList",
                                        data: e.data,
                                    });
                                    this.$store.commit("setLibraryState", {
                                        type: "customLibraryPath",
                                        data: e.msg,
                                    });
                                    let arr = e.data.map((v, k) => {
                                        v["url"] = e.msg + v.name;
                                        if (this.isPrivate) {
                                            v["key"] = v.symbol_key;
                                        }
                                        return v;
                                    });
                                    onlineList = onlineList.concat(arr);
                                    rs();
                                });
                        });
                    };
                    let getLocalDB = () => {
                        return new Promise((rs, rj) => {
                            let opendb = window.indexedDB.open("versionDB");
                            let tableName = `myDBVersion_${userInfo.user_id}`;
                            opendb.onsuccess = (e) => {
                                let db = (e.target as IDBOpenDBRequest).result;
                                const tableNames = db.objectStoreNames;
                                if (!tableNames.contains(tableName)) {
                                    db.close();
                                    rs();
                                    return;
                                }
                                let trans = db.transaction(tableName, "readonly");
                                let objstore = trans.objectStore(tableName);

                                let cursorData = [];
                                let request = objstore.openCursor();
                                request.onsuccess = (e) => {
                                    let cursor = (e.target as IDBRequest).result;
                                    if (cursor) {
                                        cursorData.push(cursor.value);
                                        cursor.continue();
                                    } else {
                                        let result = cursorData;
                                        if (result) {
                                            localList = result;
                                            rs();
                                        }
                                        // db.close();
                                    }
                                };
                            };
                        });
                    };
                    return new Promise((RS, RJ) => {
                        Promise.all([getCollect(), getCustom(), getLocalDB()])
                            // getCollect()
                            //     .then(getCustom)
                            //     .then(getLocalDB)
                            .then(() => {
                                if (onlineList.length > 0) {
                                    if (localList.length == 0) {
                                        downloadList = onlineList.map((item) => Object.assign(item, { action: "add" }));
                                    } else {
                                        deleteList = JSON.parse(JSON.stringify(localList));
                                        deleteList = deleteList.filter((item) => item.tableID != this.collectTBID);
                                        for (let i = 0; i < onlineList.length; i++) {
                                            let flag = false;
                                            for (let j = 0; j < localList.length; j++) {
                                                if (onlineList[i].table_id == localList[j].tableID) {
                                                    for (let k = 0; k < deleteList.length; k++) {
                                                        if (deleteList[k].tableID == localList[j].tableID) {
                                                            deleteList.splice(k, 1);
                                                            break;
                                                        }
                                                    }
                                                    flag = true;
                                                    if (
                                                        parseFloat(onlineList[i].version) > parseFloat(localList[j].version) ||
                                                        onlineList[i].name !== localList[j].name
                                                    ) {
                                                        Object.assign(onlineList[i], {
                                                            action: "update",
                                                        });
                                                        downloadList.push(onlineList[i]);
                                                    }
                                                    break;
                                                }
                                            }
                                            if (!flag) {
                                                Object.assign(onlineList[i], { action: "add" });
                                                downloadList.push(onlineList[i]);
                                            }
                                        }
                                    }
                                    let updateData = [],
                                        updatePromise = [],
                                        downloadErrorList = [];
                                    for (let i = 0; i < downloadList.length; i++) {
                                        let tid = downloadList[i]["table_id"];
                                        let obj = {
                                            DBName,
                                            tableName: downloadList[i]["name"],
                                            tableID: downloadList[i]["table_id"],
                                            version: downloadList[i]["version"],
                                            edtData: "",
                                            edlData: "",
                                            action: downloadList[i]["action"],
                                        };
                                        if (downloadList[i].table_id == this.openLibraryID && this.openLibraryWorkID) {
                                            // 克隆的符号模板
                                            Object.assign(obj, {
                                                cloneID: this.openLibraryWorkID,
                                                modifiedFromClone: false,
                                            });
                                        }
                                        updateData.push(obj);
                                        updatePromise.push(
                                            new Promise((res, rej) => {
                                                this.$edApi
                                                    .getCustomLibarayKey({
                                                        id: userInfo.user_id,
                                                        token: userInfo.token,
                                                        obj: downloadList[i]["url"] + ".edt",
                                                        key: downloadList[i]["key"],
                                                    })
                                                    .then((e) => {
                                                        updateData[i]["edtData"] = e.data;
                                                        res();
                                                    })
                                                    .catch((e) => {
                                                        downloadErrorList.indexOf(tid) == -1 && downloadErrorList.push(tid);
                                                        res("download error");
                                                    });
                                            })
                                        );
                                        updatePromise.push(
                                            new Promise((res, rej) => {
                                                this.$edApi
                                                    .getCustomLibarayKey({
                                                        id: userInfo.user_id,
                                                        token: userInfo.token,
                                                        obj: downloadList[i]["url"] + ".edl",
                                                        key: downloadList[i]["key"],
                                                    })
                                                    .then((e) => {
                                                        updateData[i]["edlData"] = e.data;
                                                        res();
                                                    })
                                                    .catch((e) => {
                                                        downloadErrorList.indexOf(tid) == -1 && downloadErrorList.push(tid);
                                                        res("download error");
                                                    });
                                            })
                                        );
                                    }
                                    Promise.all(updatePromise).then((e) => {
                                        let downloadFlag = true;
                                        e.forEach((v) => {
                                            if (v == "download error") {
                                                downloadFlag = false;
                                            }
                                        });
                                        if (!downloadFlag) {
                                            // 部分库下载错误，剔除同步列表
                                            for (let i = updateData.length - 1; i >= 0; i--) {
                                                if (downloadErrorList.indexOf(updateData[i].tableID) != -1) {
                                                    updateData.splice(i, 1);
                                                }
                                            }
                                        }
                                        for (let item of deleteList) {
                                            let temp = Object.assign(
                                                {
                                                    DBName,
                                                    tableName: item["name"],
                                                    tableID: item["tableID"],
                                                    action: "delete",
                                                },
                                                item
                                            );
                                            updateData.push(temp);
                                        }
                                        let worker = new Worker(this.userWorkerURL);
                                        worker.postMessage({
                                            type: "syncTable",
                                            urls: this.urls,
                                            data: {
                                                data: updateData,
                                                versionDB: `myDBVersion_${userInfo.user_id}`,
                                            },
                                        });
                                        worker.onmessage = (e) => {
                                            let message = e.data;
                                            if (message.type === "syncOK") {
                                                worker.terminate();
                                                RS();
                                            } else if (message.type == "error") {
                                                this.$store.commit("setLibraryState", {
                                                    type: "libraryError",
                                                    data: true,
                                                });
                                            }
                                        };
                                    });
                                } else {
                                    RS();
                                }
                            });
                    });
                };
                let addIntoMenu = () => {
                    return new Promise((RS, RJ) => {
                        let opendb = window.indexedDB.open("versionDB");
                        opendb.onsuccess = (e) => {
                            let db = (e.target as IDBOpenDBRequest).result;
                            let trans = db.transaction(`myDBVersion_${userID}`, "readonly");
                            let objstore = trans.objectStore(`myDBVersion_${userID}`);

                            let cursorData = [];
                            let request = objstore.openCursor();
                            request.onsuccess = (e) => {
                                let cursor = (e.target as IDBRequest).result;
                                if (cursor) {
                                    cursorData.push(cursor.value);
                                    cursor.continue();
                                } else {
                                    let result = cursorData;
                                    let length = result.length;
                                    let children = [];
                                    let showChildren = [];
                                    if (length > 0) {
                                        let collectIndex = -1;
                                        for (let i = 0; i < length; i++) {
                                            if (result[i]["tableID"] == this.collectTBID) {
                                                // 收藏库id，置于首位
                                                collectIndex = i;
                                                result[i]["tableName_zh"] = "我的收藏";
                                                break;
                                            }
                                        }
                                        result.unshift(result.splice(collectIndex, 1)[0]);
                                        result.sort((a, b) => {
                                            return a.tableID - b.tableID;
                                        });
                                        for (let i = 0; i < length; i++) {
                                            children.push({
                                                checked: false,
                                                id: result[i]["tableID"],
                                                tableName: result[i]["name"],
                                                tableName_zh: result[i]["tableName_zh"],
                                                cloneID: result[i]["cloneID"] || 0,
                                                modifiedFromClone: result[i]["modifiedFromClone"] || false,
                                            });
                                            showChildren.push({
                                                tableName: result[i]["name"],
                                                showList: [],
                                            });
                                        }
                                    }
                                    let menu = {
                                        id: 66666,
                                        show: false,
                                        groupName: myDB,
                                        indeterminate: false,
                                        checkedAll: false,
                                        checkedList: [],
                                        children: children,
                                    };
                                    let showMenu = {
                                        groupName: myDB,
                                        children: showChildren,
                                    };
                                    extraArr.push(menu);
                                    extraShowArr.push(showMenu);
                                    RS();
                                    db.close();
                                }
                            };
                        };
                    });
                };
                return checkMyDB().then(addIntoMenu);
                // return new Promise((rs) =>
                //     Promise.all([checkMyDB(), addIntoMenu()]).then(() => rs())
                // ); // 保证ts类型检查不出错
            };

            return getExtraDB().then(() => {
                // @ts-ignore
                return this.setMenuFunc(extraShowArr, extraArr, noInit);
            });
        }
        saveOrgField(url, versionObj) {
            return new Promise((RS, RJ) => {
                let DBName = "orgchartDB";
                let tableName = "orgField";
                let params = { url };
                this.$edApi.basicGet(params).then((res) => {
                    let data = res;
                    let opendb = indexedDB.open(DBName);
                    opendb.onupgradeneeded = (e) => {
                        let db = opendb.result;
                        let obj = db.objectStoreNames;
                        db.createObjectStore(tableName, { keyPath: "index" });
                    };
                    opendb.onsuccess = (e) => {
                        let db = opendb.result;
                        let trans = db.transaction(tableName, "readwrite");
                        let objstore = trans.objectStore(tableName);

                        let cursorData = [];
                        let request = objstore.openCursor();
                        request.onsuccess = (e) => {
                            let cursor = (e.target as IDBRequest).result;
                            if (cursor) {
                                cursorData.push(cursor.value);
                                cursor.continue();
                            } else {
                                let result = cursorData;

                                let action = objstore.put({
                                    index: 1,
                                    data: data,
                                });
                                new Promise((res, rej) => {
                                    trans.oncomplete = () => {
                                        res();
                                    };
                                }).then((e) => {
                                    db.close();
                                    let opendb = indexedDB.open("versionDB");
                                    opendb.onsuccess = (e) => {
                                        let db = opendb.result;
                                        let trans = db.transaction("configVersion", "readwrite");
                                        let objstore = trans.objectStore("configVersion");

                                        let index = objstore.index("configIDIndex");
                                        index.get(versionObj["configID"]).onsuccess = (e) => {
                                            // 通过索引查找原数据，如有则覆盖
                                            let data = (e.target as IDBRequest).result;
                                            if (data) {
                                                versionObj.index = data.index;
                                                objstore.put(versionObj);
                                                RS();
                                            } else {
                                                var countRequest = index.count();
                                                countRequest.onsuccess = () => {
                                                    let count = countRequest.result;
                                                    versionObj.index = count + 1;
                                                    objstore.put(versionObj);
                                                    RS();
                                                };
                                            }
                                        };
                                    };
                                });
                            }
                        };
                    };
                });
            });
        }

        isLoginStatus = false;
        closeLoading() {
            this.loading = false;
            if (window.EDCONFIG.IS_SDK) {
                this.sdkApp.promisePostMessage("LOADING_FILE_SUCCESS");
                this.setSdkZoomReset();
            }

            // 移除loading
            if (this.aiEchartData) {
                // ai创建图形时暂不移除loading状态
                return;
            }
            if (this.isLoginStatus) {
                this.$bus.$emit("nologinSave");
                return;
            }
            // let win: any = window;
            // let loadingDom = document.getElementById("loadingMask");
            // if (loadingDom) {
            //     loadingDom.style.opacity = "0";
            //     loadingDom.parentNode.removeChild(loadingDom);
            //     // setTimeout(() => {
            //     //     loadingDom.parentNode.removeChild(loadingDom);
            //     // }, 400);
            //     // 舍弃动画，没那么多空余时间
            // }

            window.postMessage(
                {
                    type: "appMounted",
                },
                "*"
            );
        }
        checkConfigFile() {
            // 判断版本库内表是否存在，不存在则新建
            let worker = new Worker(this.workerURL);
            let saveLocalConfigList = (data) => {
                if (window.localStorage) {
                    window.localStorage.setItem("configList", data.toString());
                }
            };
            let getLocalConfigList = () => {
                if (window.localStorage) {
                    return (
                        window.localStorage
                            .getItem("configList")
                            .split(",")
                            .map((v) => +v) || []
                    );
                }
            };
            let checkLocalConfig = () => {
                return new Promise((res, rej) => {
                    let opendb = window.indexedDB.open("versionDB");
                    const CONFIGID = getLocalConfigList();
                    opendb.onsuccess = (e) => {
                        let db = opendb.result;
                        let trans = db.transaction("configVersion", "readonly");
                        let objstore = trans.objectStore("configVersion");

                        let cursorData = [];
                        let request = objstore.openCursor();
                        request.onsuccess = (e) => {
                            let cursor = (e.target as IDBRequest).result;
                            if (cursor) {
                                cursorData.push(cursor.value);
                                cursor.continue();
                            } else {
                                let data = cursorData;
                                if (data) {
                                    for (let i = 0; i < data.length; ++i) {
                                        if (!CONFIGID.includes(data[i]["configID"])) {
                                            rej();
                                            break;
                                        }
                                    }
                                    res();
                                } else {
                                    rej();
                                }
                            }
                        };
                    };
                });
            };
            return new Promise((workerRes, workerRej) => {
                this.$edApi
                    .getMaxConfig()
                    .then((res) => {
                        let axiosData = res.data;
                        this.$store.commit("setStatus", {
                            type: "configList",
                            data: axiosData,
                        });
                        let host = res.msg;
                        this.$store.commit("setStatus", {
                            type: "configHost",
                            data: host,
                        });
                        let newArr = [];
                        let updateArr = [];
                        new Promise((R, J) => {
                            // 获取 versiondb 版本号
                            let opendb = window.indexedDB.open("versionDB");
                            let version = null;
                            opendb.onsuccess = (e) => {
                                version = (e.target as IDBOpenDBRequest).result.version + 1;
                                (e.target as IDBOpenDBRequest).result.close();
                                R(version);
                            };
                        }).then((version) => {
                            let opendb = window.indexedDB.open("versionDB", version as number);
                            opendb.onupgradeneeded = (e) => {
                                let db = opendb.result;
                                let nameList = null;
                                let obj = db.objectStoreNames;
                                nameList = Array.from(obj);
                                if (!nameList.includes("version")) {
                                    let store = db.createObjectStore("version", {
                                        keyPath: "index",
                                    });
                                    store.createIndex("tableIDIndex", "tableID", { unique: false });
                                }
                                if (!nameList.includes("configVersion")) {
                                    let configStore = db.createObjectStore("configVersion", {
                                        keyPath: "index",
                                    });
                                    configStore.createIndex("configIDIndex", "configID", {
                                        unique: false,
                                    });
                                }
                                let userInfo = this.$store.state.user.userInfo;
                                if (userInfo) {
                                    // if(!nameList.includes(`userDBVersion_${userInfo.user_id}`)){
                                    //     let userDBStore = db.createObjectStore(`userDBVersion_${userInfo.user_id}`, { keyPath: 'index' });
                                    //     userDBStore.createIndex('userTableIDIndex','tableID', {unique:false})
                                    // }
                                    // if(!nameList.includes(`openDBVersion_${userInfo.user_id}`)){
                                    //     let configStore = db.createObjectStore(`openDBVersion_${userInfo.user_id}`, { keyPath: 'index' });
                                    //     configStore.createIndex('openTableIDIndex','tableID', {unique:false})
                                    // }
                                    // if(!nameList.includes(`collectDBVersion_${userInfo.user_id}`)){
                                    //     let configStore = db.createObjectStore(`collectDBVersion_${userInfo.user_id}`, { keyPath: 'index' });
                                    //     configStore.createIndex('collectTableIDIndex','tableID', {unique:false})
                                    // }
                                    if (!nameList.includes(`myDBVersion_${userInfo.user_id}`)) {
                                        let configStore = db.createObjectStore(`myDBVersion_${userInfo.user_id}`, { keyPath: "index" });
                                        configStore.createIndex("myDBTableIDIndex", "tableID", {
                                            unique: false,
                                        });
                                    }
                                }
                            };
                            opendb.onsuccess = (e) => {
                                let db = opendb.result;
                                let trans = db.transaction("configVersion", "readwrite");
                                let objstore = trans.objectStore("configVersion");
                                let index = objstore.index("configIDIndex");
                                let configList = [];

                                let promiseArr = [];
                                for (let i = 0; i < axiosData.length; ++i) {
                                    if (axiosData[i].name == "groupMenu") {
                                        // 针对符号库菜单特殊处理
                                        configList.push(axiosData[i].id);
                                        this.libVersionObj = {
                                            configName: "menuList",
                                            configID: axiosData[i].id,
                                            version: axiosData[i].version,
                                        };
                                        promiseArr.push(
                                            new Promise((res, rej) => {
                                                index.get(axiosData[i].id).onsuccess = (e) => {
                                                    let data = (e.target as IDBRequest).result;
                                                    this.libFlag = true; // 需要更新
                                                    if (data) {
                                                        if (data.version == axiosData[i].version) {
                                                            this.libFlag = false;
                                                        }
                                                    }
                                                    res();
                                                };
                                            })
                                        );
                                    } else if (axiosData[i].name == "OrgFields_en.xml") {
                                        configList.push(axiosData[i].id);
                                        let versionObj = {
                                            configName: "orgchartField",
                                            configID: axiosData[i].id,
                                            version: axiosData[i].version,
                                        };
                                        promiseArr.push(
                                            new Promise((res, rej) => {
                                                index.get(axiosData[i].id).onsuccess = (e) => {
                                                    let data = (e.target as IDBRequest).result;
                                                    if (data) {
                                                        // 有数据且版本不一致 需要更新
                                                        if (data.version !== axiosData[i].version) {
                                                            this.saveOrgField(`${host}/${axiosData[i].url}`, versionObj).then((e) => {
                                                                res();
                                                            });
                                                        } else {
                                                            res();
                                                        }
                                                    } else {
                                                        this.saveOrgField(`${host}/${axiosData[i].url}`, versionObj).then((e) => {
                                                            res();
                                                        });
                                                    }
                                                };
                                            })
                                        );
                                    } else if (
                                        [
                                            ,
                                            /*'ThemeXml.tar', 'ClipPath.tar', 'ExpXml4Office.tar', 'markData.tar', 'mmThemes.tar', 'texture.tar'*/ "shapeStringXML.tar",
                                        ].includes(axiosData[i].name)
                                    ) {
                                        configList.push(axiosData[i].id);
                                        promiseArr.push(
                                            new Promise((res, rej) => {
                                                index.get(axiosData[i].id).onsuccess = (e) => {
                                                    let data = (e.target as IDBRequest).result;
                                                    if (data) {
                                                        // 有数据且版本不一致 需要更新
                                                        if (data.version !== axiosData[i].version) updateArr.push(axiosData[i]);
                                                    } else {
                                                        newArr.push(axiosData[i]);
                                                    }
                                                    res();
                                                };
                                            })
                                        );
                                    } else if (axiosData[i].name == "quickShape.tar") {
                                        // 不阻塞loading进度
                                        new Promise((res, rej) => {
                                            index.get(axiosData[i].id).onsuccess = (e) => {
                                                let data = (e.target as IDBRequest).result;
                                                this.quickShapeData = {
                                                    dbName: "QuickShape",
                                                    type: "quickShape",
                                                    url: `${host}/${axiosData[i].url}`,
                                                    dataVersionInfo: {
                                                        configName: axiosData[i].name,
                                                        configID: axiosData[i].id,
                                                        version: axiosData[i].version,
                                                    },
                                                };
                                                if (data) {
                                                    // 有数据且版本不一致 需要更新
                                                    if (data.version !== axiosData[i].version) {
                                                        res(true);
                                                    } else {
                                                        res(false);
                                                    }
                                                } else {
                                                    res(true);
                                                }
                                            };
                                        }).then((v) => {
                                            // true时需要更新库
                                            v && this.loadQuickShape();
                                        });
                                    } else if (axiosData[i].name == "aidraw.tar") {
                                        // 不阻塞loading进度
                                        new Promise((res, rej) => {
                                            index.get(axiosData[i].id).onsuccess = (e) => {
                                                let data = (e.target as IDBRequest).result;
                                                this.aiDrawData = {
                                                    dbName: "AiDraw",
                                                    type: "aidraw",
                                                    url: `${host}/${axiosData[i].url}`,
                                                    dataVersionInfo: {
                                                        configName: axiosData[i].name,
                                                        configID: axiosData[i].id,
                                                        version: axiosData[i].version,
                                                    },
                                                };
                                                if (data) {
                                                    // 有数据且版本不一致 需要更新
                                                    if (data.version !== axiosData[i].version) {
                                                        res(true);
                                                    } else {
                                                        res(false);
                                                    }
                                                } else {
                                                    res(true);
                                                }
                                            };
                                        }).then((v) => {
                                            // true时需要更新库
                                            v && this.loadAiDraw();
                                        });
                                    }
                                }
                                Promise.all(promiseArr).then((e) => {
                                    if (newArr.length > 0 || updateArr.length > 0) {
                                        let downloadArr = newArr.concat(updateArr).map((v, k) => {
                                            return {
                                                name: v.name,
                                                type: v.type,
                                                v: 1,
                                                url: `${host}/${v.url}`,
                                                dataVersionInfo: {
                                                    configName: v.name,
                                                    configID: v.id,
                                                    version: v.version,
                                                },
                                            };
                                        });
                                        let obj = {};
                                        for (let i = 0; i < downloadArr.length; ++i) {
                                            obj[downloadArr[i]["name"].match(/[a-zA-Z].[^\.]*/)] = downloadArr[i];
                                        }
                                        worker.postMessage({
                                            type: "checkDB",
                                            data: obj,
                                        });
                                        worker.onmessage = (e) => {
                                            let message = e.data;
                                            if (message.type === "loaded") {
                                                saveLocalConfigList(configList);
                                                workerRes();
                                                worker.terminate();
                                                db.close();
                                                // console.log('loaded')
                                            }
                                        };
                                    } else {
                                        workerRes();
                                        worker.terminate();
                                        db.close();
                                        // console.log('lastest')
                                    }
                                });
                            };
                        });
                    })
                    .catch((e) => {
                        checkLocalConfig()
                            .then((e) => {
                                // 检查本地是否有配置文件
                                console.log("get config fail, load local config");
                                this.libFlag = false;
                                this.getLibraryList().then((e) => {
                                    workerRes();
                                });
                            })
                            .catch((e) => {
                                let msg = this.$t("netError");
                                console.log(msg);
                            });
                    });
            });
        }
        testFile() {
            // 测试文件是否正常
            let worker = new Worker(this.workerURL);
            let obj = {
                v: 1,
                name: "ThemeXml.tar",
                type: "xml",
                url: "http://127.0.0.1:8080/ThemeXml.tar",
                dataVersionInfo: {
                    configName: "ThemeXml.tar",
                    configID: 1,
                    version: 2.6,
                },
            };
            worker.postMessage({
                type: "checkDB",
                data: {
                    ThemeXml: obj,
                },
            });
            worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "loaded") {
                    worker.terminate();
                }
            };
        }
        get vipTemplateMark() {
            return this.$store.state.vipState.vipTemplateMark;
        }

        get cummunityVipTemplateMark() {
            return this.$store.state.vipState.cummunityVipTemplateMark;
        }

        get vipSymbolMark() {
            return this.$store.state.vipState.vipSymbolMark;
        }
        get vipShapeNum() {
            return this.$store.state.vipState.vipShapeNum;
        }
        get vipPageTheme() {
            return this.$store.state.vipState.vipPageTheme;
        }
        get vipPageColor() {
            return this.$store.state.vipState.vipPageColor;
        }
        get vipPageConnect() {
            return this.$store.state.vipState.vipPageConnect;
        }
        get vipPageAutoBeautify() {
            return this.$store.state.vipState.vipPageAutoBeautify;
        }
        get vipPageBackground() {
            return this.$store.state.vipState.vipPageBackground;
        }
        get vipDoctWatermark() {
            return this.$store.state.vipState.vipDoctWatermark;
        }
        get vipDocPageNum() {
            return this.$store.state.vipState.vipDocPageNum;
        }
        get vipMath() {
            return this.$store.state.vipState.vipMath;
        }
        get vipPPTFont() {
            return this.$store.state.vipState.vipPPTFont;
        }
        get fileSource() {
            return this.$store.state.user.file_source;
        }
        setLocalShowedPopover(key: string) {
            const showPoper = () => {
                this.$bus.$emit("changePopoverVisible", true);
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$bus.$emit("changePopoverVisible", false);
                    }, 4000);
                });
            };
            let trigger = {
                watermark: "customMark",
                pptFont: "text",
                vipTemplate: "vipTemplate",
                cummunityVipTemplate: "cummunityVipTemplate",
                theme: "theme",
                themeColor: "themeColor",
                themeConnect: "connector",
                pagenum: "pageIcon",
                pageBg: "setBackgroundPop",
                autoBeautify: "oneClickBeautify",
                vipShapeNum: "vipShapeNum",
                formulaEditor: "formulaEditor",
                library: "library",
            };
            const upgradeTriggerName = trigger[key];
            const track = () => {
                const trackKey = (benefit) => {
                    this.sensors.track("popBuyNowFloatWindow", {
                        Catalogues: "payPath",
                        upgrade_trigger: upgradeTriggerName,
                        trial_vip_benefit: benefit,
                        is_unlimited_ai: !!this.purchaseBubble,
                    });
                };
                if (!this.vip) {
                    if (this.vipTemplateMark || this.cummunityVipTemplateMark) {
                        trackKey(this.cummunityVipTemplateMark ? "cummunityVipTemplate" : "vipTemplate");
                    }
                    if (this.vipSymbolMark) {
                        trackKey("library");
                    }
                    if (this.vipShapeNum) {
                        trackKey("symbolsExceedLimit");
                    }
                    if (this.vipPageTheme) {
                        trackKey("theme");
                    }
                    if (this.vipPageColor) {
                        trackKey("themeColor");
                    }
                    if (this.vipPageConnect) {
                        trackKey("connector");
                    }
                    if (this.vipPageAutoBeautify) {
                        trackKey("oneClickBeautify");
                    }
                    if (this.vipPageBackground) {
                        trackKey("setBackgroundPop");
                    }
                    if (this.vipDoctWatermark) {
                        trackKey("customMark");
                    }
                    if (this.vipDocPageNum) {
                        trackKey("pageIcon");
                    }
                    if (this.vipMath) {
                        trackKey("formulaEditor");
                    }
                    if (this.vipPPTFont) {
                        trackKey("text");
                    }
                }
            };

            // 试用vip模板不参与限制，每次都弹
            if (key == "vipTemplate" || key == "cummunityVipTemplate") {
                showPoper();
                track();
                return;
            }

            const user_id = this.userInfo ? this.userInfo.user_id : "";
            const day = new Date().getDate();
            let list = JSON.parse(localStorage.getItem("showedVipPopover") || "[]");

            // 删除非今日的数据
            list = list.filter((item) => {
                const [itemId, itemDay] = item.split("-");
                return Number(itemDay) === day;
            });

            // 今日当前用户没弹，则弹框
            const index = list.findIndex((item) => {
                const [itemId, itemDay] = item.split("-");
                return (itemId === user_id || Number(itemId) === Number(user_id)) && Number(itemDay) === day;
            });
            let vipStr = key;
            if (index != -1) {
                const [itemId, itemDay, itemType] = list[index].split("-");
                if (itemType) {
                    let funcList = itemType.split(",");
                    if (funcList.includes(key)) {
                        return;
                    } else {
                        funcList.push(key);
                        vipStr = funcList.join(",");
                    }
                }
                list.splice(index, 1, `${user_id}-${day}-${vipStr}`);
            } else {
                list.push(`${user_id}-${day}-${vipStr}`);
            }

            showPoper();
            track();

            localStorage.setItem("showedVipPopover", JSON.stringify(list));
        }
        // first in
        popMoreTemplateLock = false;
        fileLoadEnd(urlData) {
            clearTimeout(this.backTimer);
            this.getCanvasSize();
            this.vipMark(urlData);

            !this.noLoginEditor && this.setTemplateID(urlData);
            this.openLibraryID = Number(getQueryString(urlData, "openLibrary") || 0);
            this.openLibraryWorkID = Number(getQueryString(urlData, "openLibraryWorkID") || 0);
            // this.testFile();
            !this.noLoginEditor && !this.isPlugin && this.checkShareFile();
            !this.noLoginEditor && !this.isPlugin && this.isGroupView && this.checkGroupRole();
            this.setDefaultOption();
            this.showAICreate = !!(this.aiType && this.aiKeys); // url创建ai
            !this.noLoginEditor && !this.isPlugin && this.$store.dispatch("getUserLimit", "web");
            let promiseArr = [];
            const aiStatus = getQueryString(urlData, "aiStatus");
            if (aiStatus) {
                if (aiStatus === "aiDraw") {
                    this.$store.commit("setDialogState", {
                        type: "dialogType",
                        data: "AIDraw",
                    });
                    this.$store.commit("setDialogState", {
                        type: "showDialog",
                        data: true,
                    });
                } else {
                    this.$bus.$emit("showAIPanel", true);
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.$bus.$emit("aiClickImglist", aiStatus);
                        }, 500);
                    });
                }
            }
            // 未登录支持ai时启用
            // const ai4Type = getQueryString(urlData, "ai4type");
            // const ai4Text = getQueryString(urlData, "ai4text");
            // if (ai4Type && ai4Text) {
            //     this.$bus.$emit("showAIPanel", true);
            //     this.$nextTick(() => {
            //         setTimeout(() => {
            //             this.$bus.$emit("aiClickImglist", ai4Type);
            //             this.$bus.$emit("addMsgListUserMsg", ai4Text);
            //         }, 500);
            //     });
            // }

            // promiseArr.push(this.loadLibrary());
            promiseArr.push(this.checkMap());
            if (this.$store.state.ui.libraryLoadedStatus != 2) {
                let libraryLoadOverFunc = () => {
                    if (this.openLibraryID) {
                        // 填充克隆信息后同步至云
                        let list = this.menuList[0];
                        let tbName = "";
                        for (let item of list.children) {
                            if (item.id == this.openLibraryID) {
                                tbName = item.tableName;
                            }
                        }
                        this.$bus.$asyncEmit("uploadToCloud", {
                            message: {
                                type: "updateOK",
                                isUserDB: true,
                                data: {
                                    group: list.groupName,
                                    name: tbName,
                                    tableID: this.openLibraryID,
                                },
                            },
                        });
                    }
                    this.$store.commit("setStatus", {
                        type: "libraryLoadedStatus",
                        data: 2,
                    });
                    if (!this.noLoginEditor) {
                        this.showNewUserGuide();
                    } else {
                        this.openInsertTemplateModal();
                    }
                    if (localStorage.getItem("openAndShowAi")) {
                        this.$bus.$emit("showAIPanel", true);
                        localStorage.removeItem("openAndShowAi");
                        this.sensors.track("openAI", {
                            Catalogues: "AI",
                            open_way: "from_home page",
                        });
                    }
                };
                this.loadLibrary().then(() => {
                    // 延后载入符号库
                    libraryLoadOverFunc();
                    const helpGuide = localStorage.getItem("helpGuide");
                    if (helpGuide != 1) {
                        return;
                    }
                });
            }
            Promise.all(promiseArr).then((e) => {
                this.$store.commit("setStatus", {
                    type: "openFileLoading",
                    data: false,
                });
                // this.closeLoading();
                this.loadThemeConfig()?.then(() => {
                    // 上报画布加载完成埋点
                    this.sensors.track("enterJustCanvasSuccess", {
                        Catalogues: "openFileProcess",
                        file_source: this.$store.state.user.file_source,
                        template_type: this.$store.state.user.template_type,
                        team_space_file: location.hash == "#editTeam",
                    });
                });

                // window["_view"]._doc.saveToSvg(undefined,true);

                ForceSaveTimer = setTimeout(() => {
                    window["_view"].autoSave();
                }, 120000);
            });
            if (window["_view"]._doc && window["_view"]._doc._librarys) {
                this.$store.commit("setLibraryState", {
                    type: "edViewLibrarys",
                    data: window["_view"]._doc._librarys,
                });
            }
            // this.outputXML(); // for pc xml
        }
        openInsertTemplateModal() {
            // 自动打开插入模板
            const autoOpenMoreTemplate = localStorage.getItem("autoOpenMoreTemplate");
            if (!this.popMoreTemplateLock && this.fileSource == "emptyFile" && (autoOpenMoreTemplate == "1" || autoOpenMoreTemplate == null)) {
                this.popMoreTemplateLock = true;
                this.$bus.$emit("showMoreTemplates");
                this.$bus.$on("closeMoreTemplate", () => {
                    this.$bus.$off("closeMoreTemplate");
                    this.needPopover && this.setLocalShowedPopover(this.popoverStr);
                    this.$bus.$emit("showNps3");
                });
            } else {
                this.needPopover && this.setLocalShowedPopover(this.popoverStr);
                this.$bus.$emit("showNps3");
            }
        }

        needPopover = false;
        popoverStr = "";
        vipMark(urlData) {
            let vipTemplate = getQueryString(urlData, "vipTemplate");
            let cummunityVipTemplate = getQueryString(urlData, "cummunityVipTemplate");
            let needMark = vipTemplate == 1 || cummunityVipTemplate == 1;
            if (!this.vip && needMark) {
                this.needPopover = true;
                this.popoverStr = vipTemplate == 1 ? "vipTemplate" : "cummunityVipTemplate";
                window["_view"].markShapeByUseTemplate(vipTemplate == 1 ? "vipTemplate" : "cummunityVipTemplate").then(() => {
                    this.cleanURL(["vipTemplate", "cummunityVipTemplate"], urlData);
                });
            }
        }
        // createEchart
        aiEchartData = null;
        aiCreateEchart() {
            if (this.aiEchartData) {
                let filterContent = (str) => {
                    let data = str.split(/\n\s*/);
                    return data.join("");
                };
                const downCallback = () => {
                    this.aiEchartData = null;
                    this.closeLoading();
                    if (window.EDCONFIG.IS_SDK) {
                        this.$store.dispatch("autoSaveFile");
                        this.sdkApp.promisePostMessage("UPDATE_ECHART_URL");
                    }
                    this.$bus.$off("aiCreateEchartDone", downCallback);
                };
                this.$bus.$on("aiCreateEchartDone", downCallback);
                this.$bus.$emit("aiCreateEchart", filterContent(this.aiEchartData.content), this.aiEchartData.type, false);
            }
        }
        // set default option, 根据新建的模板类型设置一些默认的数据，比如16 电路图设置连接线为无箭头样式
        setDefaultOption() {
            const MINDMASTER = 211,
                ORGCHART = 37,
                ELECTRET = [103, 104, 105, 106, 107, 108],
                NETWORK = [92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102],
                UML = 62;
            let openClassID = typeof this.openClassID == "string" ? parseInt(this.openClassID) : this.openClassID;

            if (openClassID) {
                if (ELECTRET.includes(openClassID)) {
                    // 电路图
                    window["_view"].initElectetTemplate();
                } else if (openClassID == MINDMASTER) {
                    // 思维导图
                    this.loadThemeConfig()?.then((e) => {
                        window["_view"].initMMTemplate();
                    });
                } else if (openClassID == ORGCHART) {
                    // 组织结构图
                    window["_view"]._orgUITool.initOrgchartTemplate();
                } else if (NETWORK.includes(openClassID)) {
                    // 网络图
                    window["_view"].initNetworkDiagram();
                } else if (openClassID == UML) {
                    window["_view"].initUMLDiagram();
                }
            }
        }
        // 载入符号库模块
        loadLibrary() {
            return this.getLibraryList().then((e) => {
                return this.checkOpenLibrary();
            });
            // return this.getLibraryList()
        }
        // 载入快速shape
        loadQuickShape() {
            let worker = new Worker(this.workerURL);
            worker.postMessage(this.quickShapeData);
            worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "quickshape_loaded") {
                    worker.terminate();
                }
            };
        }
        // 载入快速shape
        loadAiDraw() {
            let worker = new Worker(this.workerURL);
            worker.postMessage(this.aiDrawData);
            worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "aidraw_loaded") {
                    worker.terminate();
                }
            };
        }
        // download  theme config
        loadThemeConfig() {
            if (!this.themeLoadedStatus) {
                this.themeLoadedStatus = 1;
                return new Promise((rs, rj) => {
                    this.$store.dispatch("loadConfig", ["ThemeXml.tar", "mmThemes.tar", "markData.tar"]).then((e) => {
                        let arr = [];
                        let p1 = new Promise((res) => {
                            ThemeManager.load(this.lang).then(() => {
                                window["_view"].generateCustomVip();
                                window["_view"].generateThemesIcon();
                                window["_view"].generateThemeConnectorsIcon();
                                res(true);
                            });
                        });
                        let hasMindmap = window["_view"]?._activePage?.hasMindmap();

                        let p2 = new Promise((res) => {
                            if (hasMindmap) {
                                EDDocument.s_markSheet.loadMarkData().then(() => {
                                    res(true);
                                });
                            } else {
                                res(true);
                            }
                        });
                        arr.push(p1);
                        arr.push(p2);
                        Promise.all(arr).then((e) => {
                            this.themeLoadedStatus = 2;
                            rs();
                        });
                    });
                });
            }
            return Promise.resolve();
        }
        // check echart(map)
        checkMap() {
            return new Promise((RS, RJ) => {
                const getShapeOfMapsFunc = (arr) => {
                    if (!arr || !arr.length) return [];
                    return arr.reduce((retarr, item) => {
                        if (item._chartType && item._chartType.mainType && item._chartType.mainType == "map") {
                            retarr.push(item);
                        }
                        if (item._children && item._children.length) {
                            retarr.push(...getShapeOfMapsFunc(item._children));
                        }
                        return retarr;
                    }, []);
                };
                const shapeOfMaps = getShapeOfMapsFunc(window["_view"]._doc._pages);
                if (!shapeOfMaps.length) {
                    RS();
                    return;
                }
                this.chartLoadedStatus = 1;
                this.$store.dispatch("loadConfig", ["EChartsData.tar"]).then((e) => {
                    this.chartLoadedStatus = 2;
                    // 将是map类型的图形所需要的地图数据注册进去，最小范围注册，保证加载速度。
                    EDDocument.getEChartsDataGradually(
                        [
                            ...new Set(
                                shapeOfMaps.reduce((arr, item) => {
                                    if (item._chartOption && item._chartOption.series) {
                                        if (Array.isArray(item._chartOption.series)) {
                                            const series = item._chartOption.series;
                                            arr.push(...series.filter((v) => v.type === "map").map((v) => v.map));
                                        } else {
                                            if (item._chartOption.series.type === "map") {
                                                arr.push(item._chartOption.series.map);
                                            }
                                        }
                                    }
                                    return arr;
                                }, [])
                            ),
                        ],
                        [
                            (mapData = {}) => {
                                for (let key in mapData) {
                                    echarts.registerMap(key, mapData[key]);
                                }
                                for (let v of shapeOfMaps) {
                                    v.setRelayoutFlag();
                                }
                                window["_view"].invalidate(true);
                                RS();
                            },
                            () => {
                                let MapData = EDDocument._eChartData;
                                for (let i in MapData) {
                                    for (let key in MapData[i]) {
                                        echarts.registerMap(key, MapData[i][key]);
                                    }
                                }
                            },
                        ]
                    );
                });

                // let pages = window["_view"]._doc._pages;
                // let flag = false;
                // let checkChart = (obj) => {
                //     if (!obj || !obj._children) return false;
                //     let shapeArr = obj._children;
                //     for (let k = 0; k < shapeArr.length; k++) {
                //         let shape = shapeArr[k];
                //         if (!shape) continue;
                //         if (
                //             shape._chartType &&
                //             shape._chartType.mainType &&
                //             shape._chartType.mainType == "map"
                //         ) {
                //             return true;
                //         } else if (shape._children) {
                //             if (checkChart(shape)) return true;
                //         }
                //     }
                //     return false;
                // };
                // checker: for (let i = 0; i < pages.length; i++) {
                //     if (checkChart(pages[i])) {
                //         flag = true;
                //         break checker;
                //     }
                //     // let shapeArr = pages[i]._children;
                //     // for(let j = 0; j < shapeArr.length; j++){
                //     //     if(shapeArr[j]._chartType && shapeArr[j]._chartType.mainType && shapeArr[j]._chartType.mainType == 'map'){
                //     //         flag = true
                //     //         break checker
                //     //     }
                //     // }
                // }
                // if (flag) {
                //     let worker = new Worker(this.workerURL);
                //     let loadingEnd = () => {
                //         // 加载完成后打开弹窗
                //         // 地图注册
                //         console.time('EDDocument.getEChartsData')
                //         EDDocument.getEChartsData().then((e) => {
                //             console.timeEnd('EDDocument.getEChartsData')
                //             let MapData = EDDocument._eChartData;
                //             for (let i in MapData) {
                //                 for (let key in MapData[i]) {
                //                     echarts.registerMap(key, MapData[i][key]);
                //                 }
                //             }
                //             let setChartRelayoutFlag = (obj) => {
                //                 if (!obj || !obj._children) return false;
                //                 let shapeArr = obj._children;
                //                 for (let k = 0; k < shapeArr.length; k++) {
                //                     let shape = shapeArr[k];
                //                     if (!shape) continue;
                //                     if (
                //                         shape._chartType &&
                //                         shape._chartType.mainType &&
                //                         shape._chartType.mainType == "map"
                //                     ) {
                //                         console.log(shape)
                //                         shape.setRelayoutFlag();
                //                     } else setChartRelayoutFlag(shape);
                //                 }
                //             };
                //             for (let i = 0; i < pages.length; i++) {
                //                 setChartRelayoutFlag(pages[i]);
                //                 // let shapeArr = pages[i]._children;
                //                 // for(let j = 0; j < shapeArr.length; j++){
                //                 //     if(shapeArr[j]._chartType && shapeArr[j]._chartType.mainType && shapeArr[j]._chartType.mainType == 'map'){
                //                 //         shapeArr[j].setRelayoutFlag();
                //                 //     }
                //                 // }
                //             }
                //             window["_view"].invalidate(true);
                //             RS();
                //         });
                //     };
                //     this.chartLoadedStatus = 1;
                //     console.time('EChartsData into data')
                //     this.$store.dispatch("loadConfig", ["EChartsData.tar"]).then((e) => {
                //         console.timeEnd('EChartsData into data')
                //         this.chartLoadedStatus = 2;
                //         loadingEnd();
                //     });
                // } else {
                //     // 文档中没有map形状
                //     RS();
                // }
            });
        }
        // first load library
        cleanCheckbox() {
            // 清除checkbox选中的符号库
            let tempCheckbox = JSON.parse(JSON.stringify(this.checkbox));
            let tempMenu = JSON.parse(JSON.stringify(this.menuList));

            let keyArr = Object.keys(tempCheckbox);
            for (let name of keyArr) {
                tempCheckbox[name] = [];
            }
            for (let i = 0; i < tempMenu.length; ++i) {
                tempMenu[i]["show"] = false;
                if (tempMenu[i].children.length > 0) {
                    let child = tempMenu[i].children;
                    for (let j = 0; j < child.length; ++j) {
                        child[j]["checked"] = false;
                    }
                }
            }

            this.menuList = tempMenu;
            this.checkbox = tempCheckbox;
        }
        getInfoByTableID(id) {
            let menu = this.menuList;
            let obj = {
                tableID: id,
                name: "",
                version: "",
                type: "",
                mcount: 0,
                group: "",
            };
            let url = "";
            for (let i = 0; i < menu.length; ++i) {
                if (menu[i].children.length > 0) {
                    let child = menu[i].children;
                    for (let j = 0; j < child.length; ++j) {
                        if (child[j].id == id) {
                            obj.name = child[j].tableName;
                            obj.version = child[j].version;
                            obj.type = child[j].type;
                            obj.mcount = child[j].mcount;
                            obj.group = menu[i].groupName;
                            url = child[j].url;
                            break;
                        }
                    }
                }
            }
            return { url: url, data: obj };
        }
        getInfoByTableName(name) {
            let menu = this.menuList;
            let obj = {
                tableID: 0,
                name: name,
                version: "",
                type: "",
                mcount: 0,
                group: "",
            };
            let url = "";
            for (let i = 0; i < menu.length; ++i) {
                if (menu[i].children.length > 0) {
                    let child = menu[i].children;
                    for (let j = 0; j < child.length; ++j) {
                        if (child[j].tableName == name) {
                            obj.tableID = child[j].id;
                            obj.version = child[j].version;
                            obj.type = child[j].type;
                            obj.mcount = child[j].mcount;
                            obj.group = menu[i].groupName;
                            url = child[j].url;
                            break;
                        }
                    }
                }
            }
            return { url: url, data: obj };
        }
        checkOpenLibrary() {
            // 检查文件打开符号库的情况
            const collectTBID = this.$store.state.library.collectTBID;
            let checkExit = (arr, id) => {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i]["data"]["tableID"] == id) {
                        return false;
                    }
                }
                return true;
            };
            let checkUserOptionLIb = (libObj, downloadList, activeList, customLibList) => {
                let rememberStatus = window.localStorage.getItem("rememberLib");
                if (parseInt(rememberStatus)) {
                    let libs = window.localStorage.getItem("rememberLibList") || "[]";
                    libs = JSON.parse(libs);
                    for (let i = 0; i < libs.length; ++i) {
                        let obj = this.getInfoByTableID(libs[i]);
                        if (obj.data.tableID == collectTBID) {
                            activeList.unshift(collectTBID);
                            customLibList.unshift(collectTBID);
                            continue;
                        }
                        if (obj.data.tableID > collectTBID) {
                            activeList.push(obj.data.tableID);
                            customLibList.push(obj.data.tableID);
                            continue;
                        }
                        if (obj.url != "") {
                            downloadList.push(obj);
                            if (libObj[obj["data"]["group"]]) {
                                libObj[obj["data"]["group"]].push(libs[i]);
                            } else {
                                libObj[obj["data"]["group"]] = [libs[i]];
                            }
                            activeList.push(libs[i]);
                        }
                    }
                } else {
                    activeList.unshift(collectTBID);
                    customLibList.unshift(collectTBID);
                }
            };
            let checkLocalStorage = (libObj, downloadList, activeList) => {
                // 检查localstorage内libs情况
                let libs = window.localStorage && window.localStorage.getItem("libs");
                try {
                    libs = JSON.parse(libs);
                    if (libs && libs.length > 0) {
                        // 有需要加载的库
                        for (let i = 0; i < libs.length; ++i) {
                            let obj = this.getInfoByTableID(libs[i]);
                            if (obj.data.tableID >= collectTBID) {
                                continue;
                            }
                            if (obj.url != "") {
                                downloadList.push(obj);
                                if (libObj[obj["data"]["group"]]) {
                                    libObj[obj["data"]["group"]].push(libs[i]);
                                } else {
                                    libObj[obj["data"]["group"]] = [libs[i]];
                                }
                                activeList.push(libs[i]);
                            }
                        }
                    }
                } catch (e) {}

                window.localStorage && window.localStorage.setItem("libs", "");
            };
            const checkSeoShapeHandler = (libObj, downloadList, activeList) => {
                const shapeId = Number(getQueryString(this.urlData, "shape_id"));
                const obj = this.getInfoByTableID(shapeId);

                if (obj && obj.url) {
                    let index = downloadList.findIndex((v) => v.data.tableID === shapeId);
                    if (index !== -1) {
                        downloadList.splice(index, 1);
                    }
                    downloadList.push(obj);
                    if (libObj[obj.data.group]) {
                        let i = libObj[obj.data.group].findIndex((v) => v === shapeId);
                        if (i !== -1) {
                            libObj[obj.data.group].splice(i, 1);
                        }
                        libObj[obj.data.group].push(obj.data.tableID);
                    } else {
                        libObj[obj.data.group] = [obj.data.tableID];
                    }

                    let i = activeList.findIndex((v) => v === shapeId);
                    if (i !== -1) {
                        activeList.splice(i, 1);
                    }
                    activeList.push(obj.data.tableID);
                }
            };
            return new Promise((RS, RJ) => {
                let extraDB = this.$store.state.library.extraDB;
                // this.cleanCheckbox();
                let libArr = window["_view"]._doc._librarys;
                let libObj = {};
                let tempCheckbox = JSON.parse(JSON.stringify(this.checkbox));
                let downloadList = [];
                let activeList = [];
                let customLibList = [];
                let customLibTIDList = this.menuList[0].children.map((item) => item.id);

                checkUserOptionLIb(libObj, downloadList, activeList, customLibList);
                checkLocalStorage(libObj, downloadList, activeList);
                for (let i = 0; i < libArr.length; ++i) {
                    let lid = libArr[i] - 0;
                    if (libArr[i] == this.$store.state.library.collectTBID) {
                        activeList.unshift(lid);
                        customLibList.unshift(lid);
                        continue;
                    }
                    if (libArr[i] > this.$store.state.library.collectTBID && customLibTIDList.includes(lid)) {
                        activeList.push(lid);
                        customLibList.push(lid);
                        continue;
                    }
                    if (/\@/.test(libArr[i])) {
                        let groupName = libArr[i].split("@")[1];
                        let tableId = libArr[i].split("@")[0] - 0;
                        if (!extraDB.includes(groupName)) {
                            let obj = this.getInfoByTableID(tableId);
                            if (obj.url != "" && checkExit(downloadList, obj.data["tableID"])) {
                                let groupName = obj.data.group;
                                activeList.push(obj.data["tableID"] - 0);
                                downloadList.push(obj);
                                if (libObj[groupName]) {
                                    libObj[groupName].push(tableId);
                                } else {
                                    libObj[groupName] = [tableId];
                                }
                            }
                        }
                    } else if (/\//.test(libArr[i])) {
                        let groupName = libArr[i].split("/")[1];
                        let tableName = libArr[i].split("/")[0];
                        if (!extraDB.includes(groupName)) {
                            let obj = this.getInfoByTableName(tableName);
                            if (obj.url != "" && checkExit(downloadList, obj.data["tableID"])) {
                                let groupName = obj.data.group;
                                let activeObj = `${obj.data.tableID}@${groupName}`;
                                activeList.push(obj.data["tableID"] - 0);
                                downloadList.push(obj);
                                if (libObj[groupName]) {
                                    libObj[groupName].push(obj.data.tableID);
                                } else {
                                    libObj[groupName] = [obj.data.tableID];
                                }
                            }
                        }
                    } else if (/^[0-9]+$/.test(libArr[i])) {
                        // only id
                        let tableId = libArr[i] - 0;
                        let obj = this.getInfoByTableID(tableId);
                        if (obj.url != "" && checkExit(downloadList, obj.data["tableID"])) {
                            let groupName = obj.data.group;
                            activeList.push(obj.data["tableID"] - 0);
                            downloadList.push(obj);
                            if (libObj[groupName]) {
                                libObj[groupName].push(tableId);
                            } else {
                                libObj[groupName] = [tableId];
                            }
                        }
                    }
                }

                checkSeoShapeHandler(libObj, downloadList, activeList);

                // 去重
                activeList = Array.from(new Set(activeList));
                customLibList = Array.from(new Set(customLibList.concat(customLibTIDList)));

                window["_view"]._doc._librarys = activeList.map((item) => item + "");
                if (downloadList.length != 0) {
                    let worker = new Worker(this.libraryWorkerURL);
                    worker.postMessage({
                        type: "openFile",
                        data: downloadList,
                        lang: appConfig.language,
                        urls: this.urls,
                    });
                    worker.onmessage = (e) => {
                        let message = e.data;
                        if (message.type === "loaded") {
                            let keyArr = Object.keys(libObj);
                            for (let name of keyArr) {
                                if (Object.keys(tempCheckbox).includes(name)) {
                                    tempCheckbox[name] = libObj[name];
                                } else {
                                }
                            }

                            if (EDRAWMAX_USE_CUSTOMLIBRARY) {
                                // 去除自定义库
                                tempCheckbox[this.$store.state.library.extraDB[2]] = customLibList.length ? customLibList : [];
                            }
                            if (this.openLibraryID) {
                                for (let i = 0; i < this.menuList.length; i++) {
                                    if (this.menuList[i].id == 66666) {
                                        let child = this.menuList[i].children;
                                        for (let j = 0; j < child.length; j++) {
                                            if (child[j].id == this.openLibraryID) {
                                                tempCheckbox[this.menuList[i]["groupName"]].push(this.openLibraryID);
                                                break;
                                            }
                                        }
                                    }
                                }
                                this.$bus.$emit("useStoreSymbolExpand", this.openLibraryID);
                            }
                            let localLibraryData = this.$store.state.library.publicLibraryData.reduce((prev, next) => {
                                prev[next.group] = prev[next.group] || [];
                                prev[next.group].push(next.id);
                                return prev;
                            }, {});
                            Object.keys(localLibraryData).forEach((key) => {
                                tempCheckbox[key] = [...localLibraryData[key]];
                            });
                            this.checkbox = tempCheckbox;
                            worker.terminate();
                            RS();
                        }
                        if (message.type === "process") {
                            let num = message.process;
                            this.$store.commit("setStatus", {
                                type: "LoadingProcess",
                                data: num > 1 ? 1 : num < 0 ? 0 : num,
                            });
                        }
                    };
                } else {
                    if (EDRAWMAX_USE_CUSTOMLIBRARY) {
                        // 文件 _librarys、localStorage libs 均为 []，但需要 设置 checkbox 去加载我的收藏和自定义符号库数据
                        tempCheckbox[this.$store.state.library.extraDB[2]] = customLibList.length ? customLibList : [];
                    }
                    this.checkbox = tempCheckbox;
                    this.$bus.$emit("libraryChecked");
                    RS();
                }
            });
        }
        reloadLibrary() {
            let userInfo = this.$store.state.user.userInfo;
            this.$store.commit("setLibraryState", {
                type: "libraryError",
                data: false,
            });
            let worker = new Worker(this.userWorkerURL);
            worker.postMessage({
                type: "cleanCustom",
                urls: this.urls,
                data: {
                    DBName: `myDB_${userInfo.user_id}`,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                },
            });
            worker.onmessage = (e) => {
                let message = e.data;
                if (message.type == "cleanOK") {
                    this.loadLibrary().then(() => {
                        // 载入符号库
                        this.$store.commit("setStatus", {
                            type: "libraryLoadedStatus",
                            data: 2,
                        });
                    });
                }
            };
        }
        async loadLibraryByTableId(tableId) {
            return new Promise((rs, rj) => {
                let downloadList = [];
                let obj = this.getInfoByTableID(tableId);
                downloadList.push(obj);
                let worker = new Worker(this.libraryWorkerURL);
                worker.postMessage({
                    type: "openFile",
                    data: downloadList,
                    lang: appConfig.language,
                    urls: this.urls,
                });
                worker.onmessage = (e) => {
                    let message = e.data;
                    if (message.type === "loaded") {
                        this.getTableData(tableId, obj.data.group, obj.data.name).then((data) => {
                            rs(data);
                        });
                        worker.terminate();
                    }
                };
            });
        }
        getTableData(tableId, groupName, tableName) {
            let tempData = {
                id: tableId,
                title: tableName,
                group: groupName,
                data: [],
            } as RenderLibraryData;
            let menu = this.menuList;
            for (let i = 0; i < menu.length; i++) {
                if (menu[i].groupName == groupName) {
                    let children = menu[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].id == tableId) {
                            tempData["title"] = children[j].tableName;
                            LangKeys.forEach((langKey) => {
                                tempData[langKey] = children[j][`tableName_${langKey}`];
                            });
                        }
                    }
                }
            }
            return new Promise((RS, RJ) => {
                let opendb = window.indexedDB.open(groupName);
                opendb.onsuccess = (e) => {
                    let db = (e.target as IDBOpenDBRequest).result;
                    const tableNames = db.objectStoreNames;
                    if (!tableNames.contains(tableName)) {
                        db.close();
                        RS(tempData);
                        return;
                    }
                    let transaction = db.transaction(tableName);
                    let store = transaction.objectStore(tableName);
                    let request = store.openCursor();
                    request.onsuccess = (e) => {
                        let cursor = (e.target as IDBRequest).result;
                        if (cursor) {
                            let cursordata = cursor.value;
                            if (cursordata.data) {
                                let tempIMG = cursordata.data.match(/!\[CDATA\[[^\[\]]*?\]\]/g);
                                let obj = {
                                    table_index: cursordata.index,
                                    name: cursordata.name,
                                    blob: cursordata.blob,
                                    shape: cursordata.data,
                                    table_id: cursordata.tableID || tableId,
                                    tempIMG: tempIMG ? tempIMG : [],
                                    next: cursordata.next,
                                } as LibraryItem;

                                LangKeys.forEach((langKey) => {
                                    let k = `${langKey}_name`;
                                    obj[k] = cursordata[k];
                                });

                                tempData.data.push(obj);
                            }
                            cursor.continue();
                        } else {
                            RS(tempData);
                        }
                    };
                    db.close();
                };
            });
        }

        setFileID(name) {
            // 设置文件id
            if (this.isPrivate) {
                let fileKey = name.match(/[^\/]*$/)[0];
                this.fileKey = fileKey;
                return Promise.resolve();
            }
            return new Promise((rs, rj) => {
                let params = Object.assign({ obj: name, size: 0, platform: this.$store.state.publicStore.runPlatform }, this.$store.getters.apiParam);
                this.$edApi
                    .getCloudFileSign(params)
                    .then((res) => {
                        if (res.msg === "file num over limit" || res.msg === "storage space not enough" || res.msg === "invalid file size") {
                        } else {
                            this.fileID = res.data.id;
                        }
                        rs();
                    })
                    .catch((err) => {
                        rj(err);
                    });
            });
        }
        setTemplateID(urlData) {
            // 记录克隆模板id
            let cloneID = parseInt(getQueryString(urlData, "cloneID"));
            window["_view"].setCloneData(0, cloneID);
        }
        checkShareFile() {
            // 检查是否分享文件
            if (location.hash == "#share") {
                let ts: any = this;
                ts.$bus.$emit("shareFile");
                location.hash = "";
            } else if (location.hash.indexOf("publish") > -1) {
                let ts: any = this;
                this.$store.state.ui.album.id = location.hash.replace("#publish", "");
                ts.$bus.$emit("toPublish");
                location.hash = "";
            } else if (location.hash.startsWith("#edit")) {
            } else {
                location.hash = "";
            }
        }
        checkGroupRole() {
            let params = this.$store.getters.apiParam;
            let teamId = this.$store.state.ui.editTeamOption[0];
            this.$edApi.getTeamList(params).then((res) => {
                let data = res.data;
                let role = 1;
                if (teamId != null && data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].id == teamId) {
                            role = data[i].role;
                            break;
                        }
                    }
                }
                this.$store.commit("setStatus", {
                    type: "groupRole",
                    data: role,
                });
            });
        }

        getUserTheme() {
            if (this.$store.state.user.userInfo) {
                return this.$store.dispatch("downloadCustomTheme");
            }
        }
        getToken(name) {
            var cArr = document.cookie.split(";");
            var tok;
            var cName = name + "=";
            if (document.cookie) {
                cArr.forEach(function (t) {
                    var m = t.trim();
                    if (m.indexOf(cName) === 0) {
                        tok = m.slice(cName.length);
                    }
                });
            }
            return tok || undefined;
        }
        initInclowdzEvent(message) {
            let msg: any = message.data;
            if (msg.mode == "parent2iframe" && msg.version == "v1") {
                if (msg.action == "logout") {
                    sessionStorage.setItem("userInfo", "");
                    location.href = `${window.location.origin}/online/`;
                }
            }
        }
        refreshCallback() {
            let ts = this;
            refreshToken.setCallback(
                (accessToken) => {
                    let userInfo = { ...ts.userInfo, token: accessToken };
                    this.$store.commit("setState", { type: "userInfo", data: userInfo });
                },
                () => {
                    if (this.isWorkwx) {
                        location.href = EDRAWMAX_WXREDIRECT;
                    } else if (this.isPrivate) {
                        location.href = `${location.origin}${appConfig.sourcePath}auth/auth.html`;
                    }
                }
            );
        }
        async checkUrlToken(callback) {
            let params = new URLSearchParams(location.search);
            let custom: string = params.get("custom") || "";
            if (custom && custom != "null") {
                history.replaceState(history.state, "", location.href.replace(/[\&|\?]custom\=[^\&]*/, ""));
                let obj = JSON.parse(atob(custom));
                if (obj.id == 0) return false;
                await this.$edApi.getUserInfo(obj).then((e: any) => {
                    e.data.token = obj.token;
                    e.data.refresh_token = obj.refreshToken || "";
                    e.data.islogin = true;
                    callback(e.data);
                    // set cookie
                    let exp = e.data.token.split(".")[1];
                    exp = JSON.parse(window.atob(exp)).exp;
                    let expDate = new Date(exp * 1000);
                    document.cookie = `EDCurrent=${encodeURIComponent(JSON.stringify(e.data))};expires=${expDate};path=/`;
                    $edAuth.rewriteToken(`custom=${btoa(encodeURIComponent(JSON.stringify(e.data)))}`);
                });
            }
            return Promise.reject();
        }
        afterLogined() {
            const userInfo = this.userInfo;
            const checkLimitFileNum = () => {
                this.$edApi
                    .getUserLimit({
                        id: userInfo.user_id,
                        token: userInfo.token,
                        platform: this.$store.state.publicStore.runPlatform,
                    })
                    .then((res) => {
                        let num = res.data.limit;
                        this.$store.commit("setStatus", {
                            type: "limitFileNum",
                            data: num,
                        });
                    });
            };
            checkLimitFileNum();
            this.getAppConfig();
            this.$store.dispatch("getAIOpenRecord");
            if (!window.EDCONFIG.IS_SDK) {
                this.$store.dispatch("getNalPromo", { lang: this.lang, from: "app" });
            }
            this.internal && !this.vip && this.$store.dispatch("getBuyModalCloseTimes");
            this.checkUserTag(userInfo);
        }
        checkUserTag(userInfo) {
            return new Promise((rs, rj) => {
                this.$edApi.getUserTag({ id: userInfo.user_id, token: userInfo.token }).then((res) => {
                    if (res.data.data == null) {
                    } else {
                        let data = res.data.data;
                        if (data) {
                            let identityId = data.identity_id;
                            let industryId = data.industry_id;
                            let userJob = [12, 24].includes(identityId) && data.identity_extra ? data.identity_extra : data.identity.name_cn;
                            let userIndustry = [12, 24].includes(industryId) && data.industry_extra ? data.industry_extra : data.industry.name_cn;

                            this.sensors.registerPage(
                                identityId == 8
                                    ? {
                                          user_job: userJob,
                                          user_major: userIndustry,
                                      }
                                    : {
                                          user_job: userJob,
                                          user_industry: userIndustry,
                                      }
                            );
                        }
                        rs(null);
                    }
                });
            });
        }
        checkLog() {
            if (window.EDCONFIG.IS_SDK) {
                // todo:
                return Promise.resolve();
            }
            if (this.isPlugin) {
                this.$store.commit("setState", {
                    type: "userInfo",
                    data: {
                        user_id: 0,
                        user_name: "edrawmax",
                        nick_name: "edrawmax",
                    },
                });
                return Promise.resolve();
            }
            return new Promise((RS, RJ) => {
                if (this.isInclowdz) {
                    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                    userInfo.oldInfo = true;
                    this.$store.commit("setState", { type: "userInfo", data: userInfo });
                    this.$store.dispatch("getUserInfo");
                    window.removeEventListener("message", this.initInclowdzEvent);
                    window.addEventListener("message", this.initInclowdzEvent);
                    RS(null);
                } else if (this.isWorkwx) {
                    this.refreshCallback();
                    validate()
                        .then((userInfo) => {
                            this.$store.commit("setState", { type: "userInfo", data: userInfo });
                            this.$store.dispatch("getUserInfo");
                            this.$bus.$emit("loginSucc");
                            RS(null);
                        })
                        .catch(() => {
                            location.href = EDRAWMAX_WXREDIRECT;
                        });
                } else if (this.isPrivate) {
                    this.refreshCallback();
                    validate()
                        .then((userInfo) => {
                            this.$store.commit("setState", { type: "userInfo", data: userInfo });
                            this.$store.dispatch("getUserInfo");
                            this.$bus.$emit("loginSucc");
                            RS(null);
                        })
                        .catch(() => {
                            location.href = `${location.origin}${appConfig.sourcePath}auth/auth.html`;
                        });
                } else {
                    let ts: any = this;
                    let logAction = (userInfo) => {
                        userInfo.oldInfo = true;
                        this.sensors.registerPage({
                            uid: this.internal
                                ? userInfo.user_id
                                : (userInfo.ws_info ? userInfo.ws_info.ws_id : userInfo.ws && userInfo.ws.ws_id) || 0,
                        });
                        this.$store.commit("setState", { type: "userInfo", data: userInfo });
                        this.$store.dispatch("getUserInfo").then((e) => {
                            let userInfo = e.data;
                            if (userInfo.seo_source) {
                                this.sensors.registerPage({
                                    seo_source: userInfo.seo_source,
                                });
                            }
                            if (userInfo.selfutm_term) {
                                this.sensors.registerPage({
                                    selfutm_term: userInfo.selfutm_term,
                                });
                            }
                        });
                        let lang = getHashString("lang");
                        if (ValidLang.includes(lang)) {
                            this.$store.dispatch("setUserPrefer", { language: lang });
                        }
                        this.$bus.$emit("loginSucc");
                        this.$bus.$emit("loginSucc-userTask");
                        this.afterLogined();
                    };
                    let success = (userInfo: any) => {
                        logAction(userInfo);
                        RS(null);
                    };
                    let fail = () => {
                        ts.$bus.$emit("login");
                    };
                    this.checkUrlToken(success)
                        .then(() => {
                            RS(null);
                        })
                        .catch(() => {
                            try {
                                $edAuth
                                    .checkLocalCookie()
                                    .then((userInfo: any) => {
                                        logAction(userInfo);
                                        RS(null);
                                    })
                                    .catch(() => {
                                        $edAuth.auth(success, fail, {
                                            pid: this.appPid,
                                            refreshMode: 1,
                                        });
                                    });
                            } catch (e) {
                                this.closeLoading();
                            }
                        });
                }
            });
        }
        checkCookie(key) {
            let reg = new RegExp(key);
            return reg.test(document.cookie);
        }
        showNewUserGuide() {
            const alertFunc = () => {
                this.$bus.$on("shepherdDone", () => {
                    this.$bus.$off("shepherdDone");
                    this.openInsertTemplateModal();
                });
            };
            let localData = localStorage.getItem("helpGuide") || "0";
            let openWithGuide = localStorage.getItem("openWithGuide");
            if (localData == "0") {
                if (this.userInfo.reg_time > 1660694400) {
                    this.$bus.$emit("showShepherd");
                    alertFunc();
                } else {
                    localStorage.setItem("helpGuide", "1");
                    this.openInsertTemplateModal();
                }
            } else if (openWithGuide) {
                // 例外情况：手动唤醒新手引导
                this.$bus.$emit("showShepherd");
                localStorage.removeItem("openWithGuide");
                alertFunc();
            } else {
                this.openInsertTemplateModal();
            }
        }
        addOpenRecord() {
            let params = Object.assign({ obj_id: this.fileID }, this.$store.getters.apiParam);
            if (this.isPrivate) {
                let fileKey = this.fileKey;
                params = Object.assign(params, { file_key: fileKey });
            }
            this.$edApi.addOpenRecord(params).then((e) => {
                window.opener &&
                    window.opener.postMessage(
                        {
                            type: "updateMyfile",
                            updateRecentFile: true,
                        },
                        location.origin
                    );
            });
        }
        checkStar() {
            let params = Object.assign({ obj_id: this.fileID, platform: this.$store.state.publicStore.runPlatform }, this.$store.getters.apiParam);
            if (this.isPrivate) {
                let fileKey = this.fileKey;
                params = Object.assign(params, { file_key: fileKey });
            }
            this.$edApi.getStarTag(params).then((e) => {
                let star = 0;
                if (this.isPrivate) {
                    star = e.start_tag;
                } else {
                    star = e.info ? e.info.start_tag : 0;
                }
                this.$store.commit("setStatus", {
                    type: "fileStar",
                    data: star,
                });
            });
        }
        getAppConfig() {
            if (!this.internal) return;
            let params = {
                user_id: this.userInfo.user_id,
                config_key: "aiPoints",
                platform: "web",
                pid: 0,
                v: this.appVersion,
                lang: this.lang == "zh" ? "cn" : this.lang,
            };
            this.$edApi.getAppConfig(params).then((e) => {
                if (e.data.status == "success") {
                    this.$store.commit("setStaticConfigState", e.data.data);
                }
            });
        }
        @Watch("lang")
        WatchLangChange(nv, ov) {
            if (window.EDCONFIG.IS_SDK) {
                return;
            }
            if (nv != ov && this.userInfo) {
                this.getAppConfig();
            }
        }
        get themeLoadedStatus() {
            return this.$store.state.ui.themeLoadedStatus;
        }
        set themeLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "themeLoadedStatus",
                data: v,
            });
        }
        get fileID() {
            return this.$store.state.ui.fileID;
        }
        set fileID(fileID) {
            this.$store.commit("setStatus", {
                type: "fileID",
                data: fileID,
            });
        }
        get fileKey() {
            return this.$store.state.ui.fileKey;
        }
        set fileKey(fileKey) {
            this.$store.commit("setStatus", {
                type: "fileKey",
                data: fileKey,
            });
        }
        get menuList() {
            return this.$store.state.library.menuList;
        }
        get collectTBID() {
            return this.$store.state.library.collectTBID;
        }
        get checkbox() {
            return this.$store.state.library.checkbox;
        }
        set menuList(v) {
            this.$store.commit("setLibraryState", {
                type: "menuList",
                data: v,
            });
        }
        set checkbox(v) {
            this.$store.commit("setLibraryState", {
                type: "checkbox",
                data: v,
            });
        }
        get floatMenuList() {
            return this.$store.state.dialog.floatMenuList;
        }
        get floatOptionList() {
            return this.$store.state.dialog.floatOptionList;
        }
        get showFloatBtn() {
            return this.$store.state.page.showFloatBtn;
        }
        get activeFloatItem() {
            return this.$store.state.dialog.activeFloatItem;
        }
        get activeFloatOption() {
            return this.$store.state.dialog.activeFloatOption;
        }
        get activeFloatMenu() {
            return this.floatMenuList[this.activeFloatItem];
        }
        get activeHoverFloatID() {
            return this.$store.state.dialog.activeHoverFloatID;
        }
        get svgWidth() {
            return this.$store.state.ui.svgWidth;
        }
        get svgHeight() {
            return this.$store.state.ui.svgHeight;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get libraryLoaded() {
            return this.$store.state.libtary.libraryLoaded;
        }
        get isGroupView() {
            return this.$store.state.ui.isGroupView;
        }
        get isPreviewView() {
            return this.$store.state.ui.isPreviewView;
        }
        get chartLoadedStatus() {
            return this.$store.state.ui.chartLoadedStatus;
        }
        set chartLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "chartLoadedStatus",
                data: v,
            });
        }
        get isFileLimitTip() {
            return this.$store.state.ui.isFileLimitTip;
        }
        resizeScreen() {
            if (this.resizeFlag) return;
            this.resizeFlag = true;
            setTimeout(() => {
                this.resizeFlag = false;
                this.smallscreen = window.innerWidth < 1399;
            }, 100);
        }
        resizeEchartList = throttle(() => {
            const sceneDom = document.getElementById("scene");
            const echartListRef = this.$refs.echartListRef;
            if (sceneDom && echartListRef) {
                echartListRef.style.width = sceneDom.offsetWidth - 6 + "px";
                echartListRef.style.height = sceneDom.offsetHeight - 6 + "px";
            }
        }, 100);
        get sidePanelAnimationing() {
            return this.$store.state.ui.sidePanelAnimationing;
        }

        get isSdk() {
            return window.EDCONFIG.IS_SDK;
        }
        @Watch("sidePanelAnimationing")
        WatchSidePanelAnimationing() {
            this.resizeEchartList();
        }
        filterAd(urlData) {
            // 从obj字符串中获取ad参数
            let from = getQueryString(urlData, "from");
            if (from == "ad") {
                this.$store.commit("setState", {
                    type: "isAd",
                    data: true,
                });
            }
        }
        toShowMessage(urlData) {
            let from = getQueryString(urlData, "from");
            if (from === "templates-noreject") {
                this.$edMessage.warning({
                    duration: 4,
                    content: this.$t("noreject-tips"),
                });
            }
            if (from === "templates-reject") {
                this.$edMessage.warning({
                    duration: 4,
                    content: this.$t("reject-tips"),
                });
            }
        }
        filterAI(urlData) {
            // 获取ai参数;
            this.aiType = getQueryString(urlData, "aitype");
            this.aiKeys = getQueryString(urlData, "aikeys");
        }
        closeAICreate() {
            this.showAICreate = false;
        }
        trackData(urlData) {
            let file_source = getQueryString(urlData, "file_source");
            let template_type = getQueryString(urlData, "template_type");
            let diagram_type = getQueryString(urlData, "diagram_type");
            let lv2_type = getQueryString(urlData, "lv2_type");
            let last_template_name = getQueryString(urlData, "last_template_name");
            let fromNull = getQueryString(urlData, "fromNull");
            if (location.hash === "#editShare") {
                file_source = "sharePage";
            }
            this.$store.commit("setState", {
                type: "file_source",
                data: file_source,
            });
            this.$store.commit("setState", {
                type: "template_type",
                data: template_type,
            });
            this.$store.commit("setState", {
                type: "diagram_type",
                data: diagram_type || "others",
            });
            this.$store.commit("setState", {
                type: "lv2_type",
                data: lv2_type,
            });
            this.$store.commit("setState", {
                type: "last_template_name",
                data: last_template_name,
            });
            this.$store.commit("setState", {
                type: "fromNull",
                data: fromNull ? true : false,
            });
            this.sensors.track("enterCanvas", {
                Catalogues: "openFileProcess",
                file_source,
                template_type,
                team_space_file: location.hash == "#editTeam",
            });
        }
        getCreateTime() {
            let datetime = new Date();
            let year = datetime.getFullYear();
            let month: any = datetime.getMonth() + 1; //js从0开始取
            let date: any = datetime.getDate();
            let hour: any = datetime.getHours();
            let minutes: any = datetime.getMinutes();
            let second: any = datetime.getSeconds();

            if (month < 10) {
                month = "0" + month;
            }
            if (date < 10) {
                date = "0" + date;
            }
            if (hour < 10) {
                hour = "0" + hour;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (second < 10) {
                second = "0" + second;
            }

            let time = year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + second;
            return time;
        }

        getBoardEditFile() {
            let listener = (msg) => {
                let data = msg.data;
                if (data.eventName != "boardEvent") return;
                let type = data.action;
                switch (type) {
                    case "postEddx":
                        window["_view"].openFromFile(data.eddx);
                        break;
                }
            };
            window.addEventListener("message", listener);

            window.parent.postMessage(
                {
                    eventName: "edrawmaxEvent",
                    action: "getFile",
                },
                "*"
            );
        }

        cleanURL(wordList, urlSearch) {
            if (Object.prototype.toString.call(wordList) != "[object Array]") return;
            let ts: any = this;
            let temp = "";
            let result = urlSearch;
            for (let item of wordList) {
                temp = `([\&|\?]${item}\=[^\&]*)`;
                let reg = new RegExp(temp);
                result = result.replace(reg, "");
            }
            let tempUrl = window.location.origin + appConfig["sourcePath"] + "app.html?" + ts.$zipFileName(result) + location.hash;
            history.replaceState(history.state, "", tempUrl);
            return result;
        }
        toVip() {
            this.$openBuyPage("cloudFileFloat");
        }
        get limitFileNum() {
            return this.$store.state.ui.limitFileNum || 3;
        }
        replaceLimitNum(str) {
            return str.replace(/\%fileNum\%/, this.limitFileNum);
        }
        // get showAiChat() {
        //     return this.$store.state.publicStore.showAiChat;
        // }
        // tofix: 用户在打开AI弹窗或手动触发新手向导完成前关闭窗口，会导致下次打开画布时再次出现
        // removeStore() {
        //     if (!this.showAiChat) {
        //         localStorage.removeItem("openAndShowAi");
        //     }
        // }
        setActive() {
            this.$store.commit("setStatus", {
                type: "activePanel",
                data: "canvas",
            });
        }

        // 未登录状态处理
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }

        // 设置SEO链接中模板的弹框
        checkSeoTemplateHandler() {
            const tplId = getQueryString(this.urlData, "tpl_id");
            if (tplId) {
                this.$bus.$emit("showMoreTemplatesLv2", tplId);
            }
        }
        echartListOffset = [0, 0];
        getCanvasSize() {
            let canvas = this.$refs.canvas;
            let rect = canvas.getBoundingClientRect();
            this.echartListOffset[0] = rect.left;
            this.echartListOffset[1] = rect.top;
        }
        get echartList() {
            return this.$store.state.thirdpart.echartList.filter((item) => item != null);
        }

        setVipLimitContinue(params) {
            const { triggerName, data } = params;
            if (triggerName === "playSlider") {
                if (data.isPageSlide) {
                    this.$bus.$emit("startPageSlides", data.pageIndex);
                } else {
                    this.$bus.$emit("startSliderPre", data.pageIndex);
                }
            } else if (triggerName === "removeGrid") {
                let view = window["_view"];
                if (!view) return;
                view.showGridBox(true);
                this.$store.commit("setStatus", {
                    type: "removeGrid",
                    data: true,
                });
            }
        }

        setSDKLimitShapeCount() {
            this.$store.commit("setStatus", {
                type: "isSDKLimitShapeCount",
                data: true,
            });
        }

        sdkSetUserInfo(userInfo) {
            this.$store.commit("setState", { type: "userInfo", data: userInfo });
            if (userInfo?.isSeoLink) {
                this.$store.commit("setState", {
                    type: "noLoginEditor",
                    data: true,
                });
            }
        }

        async sdkSaveFile(params = { isAuto: true }) {
            const fileData = await getSdkSaveData();
            await this.sdkApp.promisePostMessage("PUT_FILE", {
                file: fileData.file,
                img: fileData.img,
                isAuto: !!params?.isAuto,
                svgImg: fileData.svgImg,
            });
            if (AutoSaveTimer) {
                clearTimeout(AutoSaveTimer);
                AutoSaveTimer = null;
            }
        }

        get isSdk() {
            return window["EDCONFIG"].IS_SDK;
        }

        sdkInitEventListener() {
            this.sdkApp.registerPromiseEvent("GET_AI_DIAGRAM_ECHART", this.aiDiagramEchart);
            this.sdkApp.registerPromiseEvent("SET_VIP_LIMIT_CONTINUE", this.setVipLimitContinue);
            this.sdkApp.registerPromiseEvent("SET_SDK_LIMIT_SHAPE_COUNT", this.setSDKLimitShapeCount);
            this.sdkApp.registerPromiseEvent("SET_USER_INFO", this.sdkSetUserInfo);
            this.sdkApp.registerPromiseEvent("POST_SAVE_CURRENT_FILE", this.handleCopySdkCoopFile);
            this.sdkApp.registerPromiseEvent("SAVE_FILE", this.sdkSaveFile);
            this.sdkApp.registerPromiseEvent("SET_THEME", this.setSdkTheme);
            this.sdkApp.promisePostMessage("MAX_REGISTER_EVENT_SUCCESS");
            this.sdkApp.registerPromiseEvent("REFRESH_FILE", this.refreshFile);
            this.sdkApp.registerPromiseEvent("GOTO_ONLINE", this.sdkGoToOnline);
            this.sdkApp.registerPromiseEvent("DOWNLOAD_PPTX", this.sdkDownloadPptx);
        }

        refreshFile() {
            this.$store.commit("setStatus", {
                type: "isOpened",
                data: false,
            });
            this.sdkApp.promisePostMessage("GET_FILE").then((data) => {
                window["_view"].setDocName(data.name);
                window["_view"].openFromFile(data.file);
                this.$store.commit("setStatus", {
                    type: "fileStar",
                    data: data.isCollect,
                });
                this.$store.commit("setStatus", {
                    type: "seoLinkFileName",
                    data: data.name,
                });
                this.$bus.$emit("sdkResetEditNumFlag");
                // this.checkAccess();
                // this.sdkInitUserPrefer();
            });
        }

        setSdkTheme(data) {
            console.log(">>>>>>>>>>>>>>> set theme: " + data);
            window.EDCONFIG.DEFAULT_THEME = data;
            const html = document.querySelector("html");
            let removed = data === "light" ? "dark" : "light";
            html.classList.remove(removed);
            html.classList.add(data);
            let themeColor = "#017fff";
            let themeHover = "#0177f0";

            if (window.EDCONFIG.IS_SDK) {
                // 如果有别的 sdk 主题色不一致，如何区分 TODO:
                if (data === "light") {
                    themeColor = "#7755ff";
                    themeHover = "#8f6cff";
                } else {
                    themeColor = "#7755ff";
                    themeHover = "#8f6cff";
                }
            }
            this.$store.commit("setStatus", {
                type: "themeColor",
                data: themeColor,
            });
            document.body.style.setProperty("--themeColor", themeColor);
            document.body.style.setProperty("--themeHover", themeHover);
            if (this.loading) {
                const el = document.querySelector(".ed-skeleton-page");
                if (getComputedStyle(el).display === "none") {
                    el.style.display = "block";
                }
            }
            this.changePageAndCanvasTheme();
        }

        sdkGoToOnline(sdkToMaxFrom) {
            this.sdkApp.promisePostMessage("GET_USER_INFO").then((userInfo) => {
                this.sdkSetUserInfo(userInfo);
                this.$bus.$emit("sdkToOnline", sdkToMaxFrom);
            });
        }

        get exportLoadedStatus() {
            return this.$store.state.ui.exportLoadedStatus;
        }
        set exportLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "exportLoadedStatus",
                data: v,
            });
        }

        sdkDownloadPptx() {
            let type = "PowerPoint";
            this.$store.commit("setState", {
                type: "is_export_file",
                data: "exportFile",
            });

            if (!this.exportLoadedStatus) {
                this.exportLoadedStatus = 1;
                this.$store.dispatch("loadConfig", ["ExpXml4Office.tar"]).then((e) => {
                    this.exportLoadedStatus = 2;
                    this.exportOffice();
                });
            } else if (this.exportLoadedStatus == 2) {
                this.exportOffice();
            }
        }

        exportOffice() {
            let view = window["_view"];
            this.$store.commit("setState", {
                type: "is_export_file",
                data: "exportFile",
            });
            let saveToInclowdz = (data) => {
                let reader = new FileReader();
                reader.onload = function (e) {
                    window.parent.postMessage(
                        {
                            mode: "iframe2parent",
                            target: "file",
                            action: "export",
                            type: "request",
                            session_id: "0000000003",
                            version: "v1",
                            data: {
                                filename: data.name,
                                filesize: data.size,
                                base64_data: (<any>e.target).result,
                            },
                        },
                        "*"
                    );
                };
                reader.readAsDataURL(data.blob);
            };
            let haswatermark = false;
            let pptexp = new PPTExport(view._doc, haswatermark);
            pptexp.SetOptions(0.7, false, false, true);
            if (this.isInclowdz) {
                pptexp.Export(saveToInclowdz);
            } else {
                try {
                    pptexp.Export();
                } catch (e) {
                    console.log(e);
                }
            }
        }

        sdkInitUserInfo() {
            // setSdkTheme
            this.sdkApp.promisePostMessage("GET_USER_INFO").then((userInfo) => {
                this.sdkSetUserInfo(userInfo);
            });
        }

        sdkInitUserPrefer() {
            this.$store.dispatch("getUserPrefer").then((res) => {
                const userPreferData = res;
                window["_view"].parseUserPrefer(userPreferData);
            });
        }

        sdkInitFile() {
            let canvas = this.$refs.canvas;
            let scene = this.$refs.scene;
            let bgCanvas = this.$refs.bgcanvas;
            let animationcanvas = this.$refs.animationcanvas;
            let opeSvg = this.$refs.opesvg;
            let float = this.$refs.floatgroup;
            let context = this.$refs.context;
            let UI = this.$root["ui"];
            let editSet = this.$refs.editset["$el"];
            let globalCss = document.createElement("style");
            globalCss.id = "GCSS";
            document.head.appendChild(globalCss);
            let iframe = document.getElementById("edPrintIframe");
            let hcanvas = document.getElementById("UIHCanvas");
            let vcanvas = document.getElementById("UIVCanvas");
            let file_source = getQueryString(this.urlData, "file_source");
            const initEDView = () => {
                return new Promise((resolve, reject) => {
                    window["_view"] = new EDView(
                        canvas,
                        scene,
                        bgCanvas,
                        hcanvas,
                        vcanvas,
                        opeSvg,
                        float,
                        context,
                        editSet,
                        iframe,
                        animationcanvas,
                        {
                            onLoadEnd: (msg) => {
                                this.checkMap();
                                window["_view"].showRulersBox(false);
                                this.loadThemeConfig()?.then(() => {
                                    this.closeLoading();
                                    this.changePageAndCanvasTheme();
                                    if (window.EDCONFIG.AUTO_OPEN_THEME_SET_ENABLE) {
                                        setTimeout(() => {
                                            // 延迟显示主题设置，确保主题数据都加载完了
                                            this.$bus.$emit("itemChosen", "themeP", "other");
                                        }, 100);
                                    }
                                    window["_view"].changeTextCacheToSingleImage();
                                });
                                if (this.$store.state.ui.libraryLoadedStatus != 2) {
                                    this.loadLibrary().then(() => {
                                        this.$store.commit("setStatus", {
                                            type: "libraryLoadedStatus",
                                            data: 2,
                                        });
                                    });
                                }
                                this.$store.dispatch("getVersionList", {}).then(() => {});
                                this.$store.commit("setStatus", {
                                    type: "showLibrary",
                                    data: true,
                                });
                                this.$store.commit("setStatus", {
                                    type: "openFileLoading",
                                    data: false,
                                });
                                resolve();
                            },
                            onZoomEnd: () => {},
                            onPageChanged: null,
                            pageInitial: true,
                            defaultZoom: "100",
                            bkgndColor: window.EDCONFIG.DEFAULT_THEME === "dark" ? "rgb(10, 10, 10)" : "#ebebf1", // same as color sucker default
                            UI,
                            debug: false,
                            welcome: "欢迎使用亿图图示在线查看器",
                            state: "本内容并不代表亿图图示立场",
                            isNewFile: file_source == "emptyFile",
                        }
                    );
                    EDDocument._gcfg._currencyUnit = this.lang === "zh" ? "CNY" : "USD";
                    if (this.isSdk) {
                        this.$store.commit("setStatus", {
                            type: "isOpened",
                            data: false,
                        });
                    }
                    this.sdkApp.promisePostMessage("GET_FILE").then((data) => {
                        window["_view"].setDocName(data.name);
                        window["_view"].openFromFile(data.file);
                        this.$store.commit("setStatus", {
                            type: "fileStar",
                            data: data.isCollect,
                        });
                        this.$store.commit("setStatus", {
                            type: "seoLinkFileName",
                            data: data.name,
                        });
                        this.checkAccess();
                        this.sdkInitUserPrefer();
                    });
                });
            };
            const getConfig = () => {
                return this.checkConfigFile().then(() => initEDView());
            };
            const loadPreset = () => {
                return ThemeManager.loadPreset(this.lang);
            };
            Promise.all([getConfig(), loadPreset()]).then(() => {
                window["_view"].generateThemesIcon();
                window["_view"].generateThemeConnectorsIcon();
            });
        }

        sdkClearWaterMark() {
            let obj = {
                waterMarkType: 0,
                waterMarkText: "",
                waterMarkFamily: "Arial",
                waterMarkSize: -1,
                waterMarkColor: "",
                waterMarkTransparent: true,
                waterMarkPositionType: 0,
                waterMarkPosMode: 0,
            };
            window["_view"].setWatermark(obj, {}, true);
        }

        setSdkZoomReset() {
            this.activeFunc = "";
            let ts: any = this;

            this.$nextTick(() => {
                // this.toCompatFullScreen(document.documentElement);
                this.$store.commit("setStatus", {
                    type: "isFocusMode",
                    data: true,
                });
                this.$store.commit("setStatus", {
                    type: "focusExpand",
                    data: [],
                });
                localStorage.setItem("focusExpand", JSON.stringify([]));
                this.$nextTick(() => {
                    if (window["_view"]) {
                        window["_view"].onsize();
                        window["_view"]._tool.endEdit();
                        window["_view"].fitToWindow();
                        window["_view"].showGridBox(false);
                        window["_view"]._activePage._margin.reset();
                        window["_view"].setAutoSize(false, false);
                        window["_view"].drawBackground();
                        this.sdkClearWaterMark();
                    }
                });
            });
        }

        toCompatFullScreen(rootEle) {
            if (rootEle.requestFullscreen) {
                rootEle.requestFullscreen();
            } else if (rootEle.webkitRequestFullscreen) {
                rootEle.webkitRequestFullscreen();
            } else if (rootEle.mozRequestFullScreen) {
                rootEle.mozRequestFullScreen();
            } else if (rootEle.msRequestFullscreen) {
                rootEle.msRequestFullscreen();
            }
        }

        checkAccess() {
            this.sdkApp.promisePostMessage("GET_ACCESS_KEY").then((data) => {
                checkAccessKey(data);
            });
        }

        changePageAndCanvasTheme() {
            const view = window["_view"];
            if (!view) return;
            const darkThemeID = 56; // 暗黑
            const normalThemeID = 36; // 通用
            const darkBgColor = "rgba(10, 10, 10, 1)";
            const normalBgColor = "#ebebf1";

            let theme = window.EDCONFIG.DEFAULT_THEME ?? "light";

            let defaultThemeId = view.getFileDefaultThemeId(); // 文件默认的 ID
            let themeId = defaultThemeId;
            if (themeId === 0) {
                themeId = theme === "light" ? 36 : 56;
            }
            let bgColor = darkBgColor;
            // 修改默认的 id，如果改过主题则不修改, 因为 edraw ai 存的模版文件默认主题都是 56
            if (theme === "light") {
                if (defaultThemeId === darkThemeID) {
                    themeId = normalThemeID;
                }
                bgColor = normalBgColor;
            }
            if (theme === "dark" && defaultThemeId === normalThemeID) {
                themeId = darkThemeID;
            }
            this.$nextTick(() => {
                if (themeId !== defaultThemeId) {
                    this.$store.commit("setPageStat", {
                        type: "activedThemeId",
                        data: themeId,
                    });
                    this.$nextTick(() => {
                        view.changeTheme(themeId);
                    });
                }
                view.setBKndColor(bgColor);
                view._tool.endEdit();
                view._tool.selectObject(null);
            });
        }

        aiDiagramEchart(data: { mode: string; content: string; prompt: string }) {
            let type = data.mode.replace(/echart-/, "");
            this.aiEchartData = {
                content: data.content,
                type,
            };
            this.aiCreateEchart();
        }

        async handleCopySdkCoopFile() {
            const fileData = await getSdkSaveData();
            await this.sdkApp.promisePostMessage("POST_COPY_COOP_FILE", { file: fileData.file, img: fileData.img, svgImg: fileData.svgImg });
            this.$edMessage.success(this.$t("copy success"));
            return;
        }

        onWheelEchartList(e) {
            const sceneDiv = document.getElementById("scene");
            if (sceneDiv) {
                sceneDiv.scrollBy({
                    top: !e.shiftKey ? e.deltaY : 0,
                    left: e.shiftKey ? e.deltaY : 0,
                    behavior: "smooth",
                });
            }
        }

        async mounted() {
            // window.addEventListener('resize', this.resizeScreen)
            this.smallscreen = window.innerWidth < 1399;
            let ts: any = this;
            let urlData = `temp=${window.location.search.substr(1)}`;
            if (!this.isPlugin) {
                const fileName = getQueryString(urlData, "temp");
                if (!fileName) return;
                urlData = ts.$unZipFileName(fileName);
            }
            this.urlData = urlData;
            let obj = getQueryString(urlData, "obj");
            let plugin = getQueryString(urlData, "plugin");
            this.$store.commit("setStatus", {
                type: "fileInfo",
                data: obj,
            });
            let tempFile;
            let PromiseArr = [];
            let canvas = this.$refs.canvas;
            let scene = this.$refs.scene;
            let bgCanvas = this.$refs.bgcanvas;
            let animationcanvas = this.$refs.animationcanvas;
            let opeSvg = this.$refs.opesvg;
            let float = this.$refs.floatgroup;
            let context = this.$refs.context;
            let UI = this.$root["ui"];
            let editSet = this.$refs.editset["$el"];
            let globalCss = document.createElement("style");
            globalCss.id = "GCSS";
            document.head.appendChild(globalCss);
            const type = getQueryString(urlData, "type");
            const checkType = () => {
                if (["pre_edit", "create_echart", "seo_link"].includes(type)) {
                    this.$store.commit("setState", {
                        type: "noLoginEditor",
                        data: true,
                    });
                    return Promise.resolve();
                } else if (window.EDCONFIG.IS_SDK) {
                    return Promise.resolve();
                } else {
                    return this.checkLog();
                }
            };
            this.isLoginStatus = this.checkCookie("EDCurrent") && ["pre_edit", "create_echart"].includes(type);
            checkType()
                .then((e) => {
                    if (window.EDCONFIG.IS_SDK) {
                        ts.$store.commit("changeUILang", appConfig.language);
                        ts.sdkInitUserInfo();
                        ts.sdkInitFile();
                        return;
                    }

                    this.backupUserInfo = this.userInfo; // 判断两次登录是否是同一用户
                    // let userInfo = app.$store.state.user.userInfo;  // 删除自定义库数据，测试使用
                    // app.$edApi.deleteCustomLibrary({id: userInfo.user_id,token: userInfo.token,libs: 8}).then(e => {})
                    // return
                    if (this.isPlugin) {
                        this.checkConfigFile().then((e) => {
                            let iframe = document.getElementById("edPrintIframe");
                            let hcanvas = document.getElementById("UIHCanvas");
                            let vcanvas = document.getElementById("UIVCanvas");
                            let file_source = getQueryString(urlData, "file_source");
                            window["_view"] = new EDView(
                                canvas,
                                scene,
                                bgCanvas,
                                hcanvas,
                                vcanvas,
                                opeSvg,
                                float,
                                context,
                                editSet,
                                iframe,
                                animationcanvas,
                                {
                                    onLoadEnd: () => {
                                        let urlData = `temp=${window.location.search.substr(1)}`;
                                        if (!this.isPlugin) {
                                            const fileName = getQueryString(urlData, "temp");
                                            urlData = ts.$unZipFileName(fileName);
                                        }
                                        this.$store.commit("setStatus", {
                                            type: "viewLoadDone",
                                            data: true,
                                        });
                                        this.fileLoadEnd(urlData);
                                        window["_view"].showRulersBox(false);
                                        window["_view"].changeTextCacheToSingleImage();
                                    },
                                    onZoomEnd: () => {},
                                    onPageChanged: null,
                                    pageInitial: true,
                                    defaultZoom: "100",
                                    bkgndColor: "#ebebf1", // same as color sucker default
                                    UI,
                                    debug: false,
                                    welcome: "欢迎使用亿图图示在线查看器",
                                    state: "本内容并不代表亿图图示立场",
                                    isNewFile: file_source == "emptyFile",
                                }
                            );

                            if (this.lang === "zh") EDDocument._gcfg._currencyUnit = "CNY";
                            else EDDocument._gcfg._currencyUnit = "USD";

                            ThemeManager.loadPreset(this.lang).then(() => {
                                if (plugin == "board") {
                                    let type = getQueryString(urlData, "useTemplate"),
                                        tid = getQueryString(urlData, "tid");
                                    if (tid) {
                                        this.$edApi
                                            .getTemplateSign({
                                                type,
                                                tid,
                                            })
                                            .then((e) => {
                                                let res = e.data.data;
                                                let url = res.url;
                                                this.$edApi.downloadConvertFile({ url }).then((res) => {
                                                    window["_view"].openFromFile(res.data);
                                                });
                                            });
                                        this.cleanURL(["useTemplate", "tid"], urlData);
                                    } else {
                                        window["_view"].newFile();
                                    }
                                } else if (plugin == "boardEdit") {
                                    this.$store.commit("setStatus", {
                                        type: "isPreviewView",
                                        data: true,
                                    });
                                    this.getBoardEditFile();
                                }
                            });
                            this.$store.commit("setStatus", {
                                type: "showLibrary",
                                data: true,
                            });

                            window["_view"].generateCustomVip();
                            window["_view"].generateThemesIcon();
                            window["_view"].generateThemeConnectorsIcon();
                        });

                        return;
                    }
                    !this.isWorkwx && this.$store.dispatch("getUserHelp");

                    const createEmptyFile = () => {
                        let getCreateTime = () => {
                            let datetime = new Date();
                            let year = datetime.getFullYear();
                            let month: number | string = datetime.getMonth() + 1; //js从0开始取
                            let date: number | string = datetime.getDate();
                            let hour: number | string = datetime.getHours();
                            let minutes: number | string = datetime.getMinutes();
                            let second: number | string = datetime.getSeconds();

                            if (month < 10) {
                                month = "0" + month;
                            }
                            if (date < 10) {
                                date = "0" + date;
                            }
                            if (hour < 10) {
                                hour = "0" + hour;
                            }
                            if (minutes < 10) {
                                minutes = "0" + minutes;
                            }
                            if (second < 10) {
                                second = "0" + second;
                            }

                            let time = year + "/" + month + "/" + date + " " + hour + ":" + minutes + ":" + second;
                            return time;
                        };
                        let index = this.internal ? 0 : 1,
                            docName = `${this.$tc("newFile")}.eddx`,
                            screenW = window.screen.width * window.devicePixelRatio,
                            screenH = window.screen.height * window.devicePixelRatio,
                            createTime = getCreateTime(),
                            creater = "EdrawAi",
                            maxVersion = this.appVersion;
                        let createTool = new CreateNewFile(index, docName, screenW, screenH, createTime, creater, maxVersion, [], this.vip, false);
                        return createTool.createFile();
                    };

                    // 提前下载文档
                    const downloadFilePromise = new Promise((resolve, reject) => {
                        const type = getQueryString(urlData, "type");
                        if (
                            /.eddx/i.test(urlData) &&
                            !["localFile", "dropbox", "google"].includes(type) &&
                            this.userInfo &&
                            !["#create", "#editShare", "#editTeam"].includes(location.hash)
                        ) {
                            const key = getQueryString(urlData, "obj");
                            this.$store.dispatch("downloadFiles", key).then(resolve).catch(reject);
                        } else if (type == "pre_edit") {
                            const file_id = getQueryString(urlData, "file_id");
                            if (file_id) {
                                axios
                                    .get(`${urls.edrawmaxApi}/api/ai/v1/completions/native/url?native_id=${file_id}`)
                                    .then((res) => {
                                        let url = res.data.data.file_link;
                                        return url;
                                    })
                                    .then((url) => {
                                        this.$edApi
                                            .downloadConvertFile({
                                                url: url,
                                            })
                                            .then(resolve)
                                            .catch(reject);
                                    });
                            } else {
                                reject();
                            }
                        } else if (type == "create_echart") {
                            const file_id = getQueryString(urlData, "echart_id");
                            if (file_id) {
                                return Promise.all([
                                    axios.get(`${urls.edrawmaxApi}/api/ai/v1/completions/native/asst?native_id=${file_id}`).then((res) => {
                                        let data = res.data.data;
                                        let type = data.mode.replace(/echart-/, "");
                                        return {
                                            content: data.content,
                                            type,
                                        };
                                    }),
                                    createEmptyFile(),
                                ]).then(resolve);
                            } else {
                                reject();
                            }
                        } else if (type === "seo_link") {
                            const work_id = getQueryString(urlData, "work_id");
                            const tpl_id = getQueryString(urlData, "tpl_id");
                            const shape_id = getQueryString(urlData, "shape_id");

                            if (!work_id && !tpl_id && !shape_id) {
                                reject();
                            }

                            if (work_id || tpl_id || shape_id) {
                                this.$store.commit("setState", {
                                    type: "seo_source",
                                    data: `3-${work_id || 0}_${tpl_id || 0}_${shape_id || 0}`,
                                });
                            }

                            if (work_id) {
                                axios
                                    .get(`${urls.apiUrl}/api/guest/work/sign?work_id=${work_id}&platform=web&source=seo_link`)
                                    .then((res) => {
                                        let url = res.data.data.url;
                                        return url;
                                    })
                                    .then((url) => {
                                        this.$edApi
                                            .downloadConvertFile({
                                                url: url,
                                            })
                                            .then(resolve)
                                            .catch(reject);
                                    });
                            } else {
                                return Promise.all([createEmptyFile()]).then(resolve);
                            }
                        } else {
                            reject();
                        }
                    });

                    const initEDView = () =>
                        new Promise((resolve) => {
                            let iframe = document.getElementById("edPrintIframe");
                            let hcanvas = document.getElementById("UIHCanvas");
                            let vcanvas = document.getElementById("UIVCanvas");
                            let file_source = getQueryString(urlData, "file_source");
                            window["_view"] = new EDView(
                                canvas,
                                scene,
                                bgCanvas,
                                hcanvas,
                                vcanvas,
                                opeSvg,
                                float,
                                context,
                                editSet,
                                iframe,
                                animationcanvas,
                                {
                                    onLoadEnd: () => {
                                        let urlData = `temp=${window.location.search.substr(1)}`;
                                        if (!this.isPlugin) {
                                            const fileName = getQueryString(urlData, "temp");
                                            urlData = ts.$unZipFileName(fileName);
                                        }
                                        this.$store.commit("setStatus", {
                                            type: "viewLoadDone",
                                            data: true,
                                        });
                                        this.aiCreateEchart();
                                        this.closeLoading();
                                        // 关闭loading后，先不往下执行，先立即留点时间给渲染进程赶紧绘制更新视图
                                        setTimeout(() => {
                                            this.fileLoadEnd(urlData);
                                            window["_view"].showRulersBox(false);
                                            window["_view"].changeTextCacheToSingleImage();
                                        }, 50);
                                        this.toShowMessage(urlData);
                                        resolve();
                                    },
                                    onZoomEnd: () => {},
                                    onPageChanged: null,
                                    pageInitial: true,
                                    defaultZoom: "100",
                                    bkgndColor: "#ebebf1", // same as color sucker default
                                    UI,
                                    debug: false,
                                    welcome: "欢迎使用亿图图示在线查看器",
                                    state: "本内容并不代表亿图图示立场",
                                    isNewFile: file_source == "emptyFile",
                                }
                            );

                            if (this.lang === "zh") EDDocument._gcfg._currencyUnit = "CNY";
                            else EDDocument._gcfg._currencyUnit = "USD";

                            if (!urlData) {
                                return;
                            }

                            // localFile
                            if (type === "localFile") {
                                this.$store.commit("setStatus", {
                                    type: "isLocalFile",
                                    data: true,
                                });
                                let name = getQueryString(urlData, "name");
                                window["_view"].setDocName(name.match(/.*(?=\.eddx)/i)[0]);
                                window["_view"].openFromFile(tempFile);
                            }
                            // dropbox
                            else if (type === "dropbox") {
                                let obj = getQueryString(urlData, "obj");
                                let dropboxToken = localStorage.getItem("dropbox_access_token");
                                let dbx;
                                if (!dropboxToken) {
                                    dbx = new Dropbox({
                                        clientId: "5bt9id87y41ps12",
                                    });
                                    let org = window.location.origin + (<any>this.$router).options.base + "dropboxcallback";
                                    let authurl = dbx.getAuthenticationUrl(org);
                                    // location.href = authurl;
                                    window.open(authurl);
                                } else {
                                    dbx = new Dropbox({
                                        accessToken: dropboxToken,
                                    });
                                    dbx.filesDownload({ path: obj })
                                        .then((res) => {
                                            console.log("%c download Dropbox File", "color:green");
                                            window["_view"].setDocName(res.name);
                                            window["_view"].openFromFile(res.fileBlob);
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                        });
                                }
                            }
                            // google
                            else if (type === "google") {
                                let fileId = getQueryString(urlData, "obj");
                                let google = googleApi();
                                google.loadClient().then((res) => {
                                    google.initClient().then((res) => {
                                        let isSignedIn = google.AuthManager.isSignedIn();
                                        if (!isSignedIn) {
                                            google.AuthManager.signIn();
                                        } else {
                                            google.FileManager.getFile({
                                                fileId: fileId,
                                            }).then((res) => {
                                                window["_view"].setDocName(res.result.name);
                                            });
                                            google.FileManager.downloadFile({
                                                fileId: fileId,
                                            }).then((fileData) => {
                                                window["_view"].openFromFile(fileData);
                                            });
                                        }
                                    });
                                });
                            } else if (/.eddx/i.test(urlData)) {
                                if (!this.userInfo) {
                                    let ts: any = this;
                                    ts.$bus.$emit("login");
                                    return;
                                }
                                if (location.hash == "#create") {
                                    this.$store.commit("setStatus", {
                                        type: "showLibrary",
                                        data: true,
                                    });
                                    let addLibs = () => {
                                        try {
                                            let libs: any = window.localStorage && window.localStorage.getItem("libs");
                                            libs = libs ? JSON.parse(libs) : [];
                                            libs.unshift(this.$store.state.library.collectTBID);
                                            window["_view"]._doc._librarys = libs;
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    };
                                    this.$nextTick(() => {
                                        window["_view"].newFile();
                                        let key = getQueryString(urlData, "obj");
                                        this.trackData(urlData);
                                        this.filterAd(urlData);
                                        window["_view"].setDocName(key.match(/[^\/]*(?=\.eddx)/i)[0]);
                                        let urlSearch = obj;
                                        addLibs();
                                        this.$store
                                            .dispatch("autoSaveFile", { urlSearch })
                                            .then((res) => {
                                                this.setFileID(key).then(() => {
                                                    if (this.fileID != 0) {
                                                        this.addOpenRecord();
                                                        this.checkStar();
                                                    }
                                                });
                                                if (window.opener) {
                                                    window.opener.postMessage(
                                                        {
                                                            type: "updateFiles",
                                                        },
                                                        location.origin
                                                    );
                                                }
                                            })
                                            .catch((err) => {
                                                console.log(err);
                                                this.closeLoading();
                                                (<any>this).$edMessage.warning(this.$t("creatFileFail"));
                                                // setTimeout(() => {
                                                //     window.close()
                                                // }, 3000)
                                            });
                                    });
                                } else if (location.hash == "#editShare") {
                                    let key = getQueryString(urlData, "obj");
                                    this.filterAd(urlData);
                                    this.trackData(urlData);
                                    window["_view"].setDocName(key.match(/[^\/]*(?=\.eddx)/i)[0]);
                                    let getUUIDflag = false;
                                    let msgFunc = (e) => {
                                        let uuid = e.data.uuid;
                                        let shareOption = e.data.option;
                                        let share_id = e.data.share_id;
                                        console.log(uuid);
                                        getUUIDflag = true;
                                        this.$store.commit("setStatus", {
                                            type: "shareUUID",
                                            data: uuid,
                                        });
                                        this.$store.commit("setStatus", {
                                            type: "shareOption",
                                            data: shareOption,
                                        });
                                        this.$store.commit("setStatus", {
                                            type: "isShareEditFile",
                                            data: true,
                                        });
                                        this.$store.commit("setStatus", {
                                            type: "shareId",
                                            data: share_id,
                                        });
                                        window.addEventListener("beforeunload", (e) => {
                                            navigator.sendBeacon(
                                                this.urls.apiUrl +
                                                    `/api/user/${this.userInfo.user_id}/max/share/edit/${uuid}/release/${this.userInfo.token}`
                                            );
                                        });
                                        this.$store
                                            .dispatch("downloadShareFiles", { obj: key, uuid })
                                            .then((data) => {
                                                if (this.internal) {
                                                    this.$store.commit("setStatus", {
                                                        type: "shareEtag",
                                                        data: data.headers.etag.slice(1, -1),
                                                    });
                                                }
                                                this.$store.commit("setStatus", {
                                                    type: "showLibrary",
                                                    data: true,
                                                });
                                                window["_view"].openFromFile(data.data);
                                            })
                                            .catch((err) => {
                                                this.closeLoading();
                                                if (err === "Not allowed") {
                                                    (<any>this).$edMessage.warning(this.$t("shareAuthFail"));
                                                } else if ((err = "not found")) {
                                                    (<any>this).$edMessage.warning(this.$t("shareCancel"));
                                                } else {
                                                    (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                                }
                                                // setTimeout(window.close, 3000)
                                            });
                                        window.removeEventListener("message", msgFunc);
                                    };
                                    window.addEventListener("message", msgFunc);
                                    window.opener && window.opener.postMessage("reqSendUUID", "*");
                                    setTimeout(() => {
                                        if (!getUUIDflag) {
                                            this.$edMessage.warning(this.$t("uuidError"));
                                        }
                                    }, 1000);
                                } else if (location.hash == "#editShare") {
                                    let key = getQueryString(urlData, "obj");
                                    this.filterAd(urlData);
                                    window["_view"].setDocName(key.match(/[^\/]*(?=\.eddx)/i)[0]);
                                    let getUUIDflag = false;
                                    let msgFunc = (e) => {
                                        if (
                                            location.hostname != "10.10.17.37" &&
                                            e.origin !== "https://www.edrawsoft.cn" &&
                                            e.origin !== "https://www.edrawmax.cn" &&
                                            e.origin !== "https://www.edrawmax.com"
                                        ) {
                                            return;
                                        }
                                        let uuid = e.data.uuid;
                                        let shareOption = e.data.option;
                                        let share_id = e.data.share_id;
                                        console.log(uuid);
                                        getUUIDflag = true;
                                        this.$store.commit("setStatus", {
                                            type: "shareUUID",
                                            data: uuid,
                                        });
                                        this.$store.commit("setStatus", {
                                            type: "shareOption",
                                            data: shareOption,
                                        });
                                        this.$store.commit("setStatus", {
                                            type: "isShareEditFile",
                                            data: true,
                                        });
                                        this.$store.commit("setStatus", {
                                            type: "shareId",
                                            data: share_id,
                                        });
                                        window.addEventListener("beforeunload", (e) => {
                                            navigator.sendBeacon(
                                                this.urls.apiUrl +
                                                    `/api/user/${this.userInfo.user_id}/max/share/edit/${uuid}/release/${this.userInfo.token}`
                                            );
                                        });
                                        this.$store
                                            .dispatch("downloadShareFiles", { obj: key, uuid })
                                            .then((data) => {
                                                if (this.internal) {
                                                    this.$store.commit("setStatus", {
                                                        type: "shareEtag",
                                                        data: data.headers.etag.slice(1, -1),
                                                    });
                                                }
                                                this.$store.commit("setStatus", {
                                                    type: "showLibrary",
                                                    data: true,
                                                });
                                                window["_view"].openFromFile(data.data);
                                            })
                                            .catch((err) => {
                                                this.closeLoading();
                                                if (err === "Not allowed") {
                                                    (<any>this).$edMessage.warning(this.$t("shareAuthFail"));
                                                } else if ((err = "not found")) {
                                                    (<any>this).$edMessage.warning(this.$t("shareCancel"));
                                                } else {
                                                    (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                                }
                                                // setTimeout(window.close, 3000)
                                            });
                                        window.removeEventListener("message", msgFunc);
                                    };
                                    window.addEventListener("message", msgFunc);
                                    window.opener && window.opener.postMessage("reqSendUUID", "*");
                                    setTimeout(() => {
                                        if (!getUUIDflag) {
                                            this.$edMessage.warning(this.$t("uuidError"));
                                        }
                                    }, 1000);
                                } else if (location.hash == "#editTeam") {
                                    this.$store.commit("setStatus", {
                                        type: "isGroupView",
                                        data: true,
                                    });
                                    this.$store.commit("setStatus", {
                                        type: "isPreviewView",
                                        data: true,
                                    });
                                    this.$store.commit("setStatus", {
                                        type: "isTeamFile",
                                        data: true,
                                    });
                                    let key = getQueryString(urlData, "obj");
                                    this.trackData(urlData);
                                    this.filterAd(urlData);
                                    window["_view"].setDocName(key.match(/[^\/]*(?=\.eddx)/i)[0]);
                                    let teamId = localStorage.getItem("editTeamId");
                                    let objId = localStorage.getItem("editTeamObjId");
                                    this.$store.commit("setStatus", {
                                        type: "editTeamOption",
                                        data: [teamId, objId],
                                    });
                                    window.addEventListener("beforeunload", (e) => {
                                        navigator.sendBeacon(
                                            this.urls.apiUrl +
                                                `/api/user/${this.userInfo.user_id}/max/team/${teamId}/obj/${objId}/release/${this.userInfo.token}`
                                        );
                                    });
                                    this.$store
                                        .dispatch("downloadTeamFiles", { obj: key, teamId, objId })
                                        .then((data) => {
                                            this.$store.commit("setStatus", {
                                                type: "showLibrary",
                                                data: true,
                                            });
                                            window["_view"].openFromFile(data.data);
                                        })
                                        .catch((err) => {
                                            this.closeLoading();
                                            if (err === "Not allowed") {
                                                (<any>this).$edMessage.warning(this.$t("shareAuthFail"));
                                            } else if (err.msg === "renamed") {
                                                (<any>this).$edMessage.warning(this.$t("fileRenamed"));
                                            } else if ((err = "not found")) {
                                                (<any>this).$edMessage.warning(this.$t("fileDeleted"));
                                            } else {
                                                (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                            }
                                            // setTimeout(window.close, 3000)
                                        });
                                } else {
                                    let hash = location.hash;
                                    // 新手任务
                                    if (location.hash == "#fileTask") {
                                        this.$bus.$emit("forceClose");
                                        this.$bus.$emit("userTaskSucc");
                                        hash = "";
                                    }
                                    let key = getQueryString(urlData, "obj");

                                    this.trackData(urlData);
                                    this.filterAd(urlData);
                                    this.filterAI(urlData);
                                    this.openClassID = getQueryString(urlData, "classID");
                                    let preview = getQueryString(urlData, "preview");
                                    if (preview) {
                                        this.$store.commit("setStatus", {
                                            type: "isPreviewView",
                                            data: true,
                                        });
                                    }
                                    let fileLimitTip = getQueryString(urlData, "fileLimitTip");
                                    if (fileLimitTip) {
                                        this.$store.commit("setStatus", {
                                            type: "isFileLimitTip",
                                            data: true,
                                        });
                                    }
                                    const cleanList = ["aitype", "aikeys", "classID"];
                                    if (file_source == "emptyFile") {
                                        // 刷新url后不再是新建空白文件
                                        cleanList.push("file_source");
                                    }
                                    urlData = this.cleanURL(cleanList, urlData);
                                    let docName = key.match(/[^\/]*(?=\.eddx)/i)?.[0];
                                    if (docName) {
                                        window["_view"].setDocName(docName);
                                    }
                                    this.setFileID(key).then(() => {
                                        this.addOpenRecord();
                                        this.checkStar();
                                    });
                                    // this.$store.dispatch("downloadFiles", key)
                                    downloadFilePromise
                                        .then((data: any) => {
                                            this.$store.commit("setStatus", {
                                                type: "showLibrary",
                                                data: true,
                                            });
                                            window["_view"].openFromFile(data.data);
                                        })
                                        .catch((err) => {
                                            this.closeLoading();
                                            (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                            // setTimeout(window.close, 3000)
                                        });
                                }
                            } else if (this.isPrivate) {
                                if (!this.userInfo) {
                                    let ts: any = this;
                                    ts.$bus.$emit("login");
                                    return;
                                }
                                let docName = getQueryString(urlData, "name");
                                if (location.hash == "#editShare") {
                                    let key = getQueryString(urlData, "obj");
                                    this.filterAd(urlData);
                                    window["_view"].setDocName(docName);
                                    let getUUIDflag = false;
                                    let msgFunc = (e) => {
                                        // if (e.origin !== "https://www.edrawsoft.cn" && e.origin !== "https://www.edrawmax.cn" && e.origin !== "https://www.edrawmax.com" ){
                                        //     return;
                                        // }
                                        let uuid = e.data.uuid;
                                        let shareOption = e.data.option;
                                        console.log(uuid);
                                        getUUIDflag = true;
                                        this.$store.commit("setStatus", {
                                            type: "shareUUID",
                                            data: uuid,
                                        });
                                        this.$store.commit("setStatus", {
                                            type: "shareOption",
                                            data: shareOption,
                                        });
                                        this.$store.commit("setStatus", {
                                            type: "isShareEditFile",
                                            data: true,
                                        });
                                        let fileKey = key.match(/[^\/]*$/)[0];
                                        this.fileKey = fileKey;
                                        let unloadUrl =
                                            this.urls.apiUrl +
                                            `/api/user/${this.userInfo.user_id}/max/share/edit/${uuid}/release/${this.userInfo.token}`;
                                        if (this.isPrivate) {
                                            unloadUrl =
                                                this.urls.apiUrl +
                                                `/api/web/user/${this.userInfo.user_id}/max/share/edit/${uuid}/release/${this.userInfo.token}`;
                                        }
                                        window.addEventListener("beforeunload", (e) => {
                                            navigator.sendBeacon(unloadUrl);
                                        });
                                        this.$store
                                            .dispatch("downloadShareFiles", {
                                                obj: key,
                                                uuid,
                                                file_key: fileKey,
                                            })
                                            .then((data) => {
                                                if (this.internal) {
                                                    this.$store.commit("setStatus", {
                                                        type: "shareEtag",
                                                        data: data.headers.etag ? data.headers.etag.slice(1, -1) : "",
                                                    });
                                                }
                                                this.$store.commit("setStatus", {
                                                    type: "showLibrary",
                                                    data: true,
                                                });
                                                window["_view"].openFromFile(data.data);
                                            })
                                            .catch((err) => {
                                                this.closeLoading();
                                                if (err === "Not allowed") {
                                                    (<any>this).$edMessage.warning(this.$t("shareAuthFail"));
                                                } else if ((err = "not found")) {
                                                    (<any>this).$edMessage.warning(this.$t("shareCancel"));
                                                } else {
                                                    (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                                }
                                                // setTimeout(window.close, 3000)
                                            });
                                        window.removeEventListener("message", msgFunc);
                                    };
                                    window.addEventListener("message", msgFunc);
                                    window.opener && window.opener.postMessage("reqSendUUID", "*");
                                    setTimeout(() => {
                                        if (!getUUIDflag) {
                                            this.$edMessage.warning(this.$t("uuidError"));
                                        }
                                    }, 1000);
                                } else if (location.hash == "#editTeam") {
                                    this.$store.commit("setStatus", {
                                        type: "isGroupView",
                                        data: true,
                                    });
                                    this.$store.commit("setStatus", {
                                        type: "isPreviewView",
                                        data: true,
                                    });
                                    this.$store.commit("setStatus", {
                                        type: "isTeamFile",
                                        data: true,
                                    });
                                    let key = getQueryString(urlData, "obj");
                                    this.filterAd(urlData);
                                    window["_view"].setDocName(docName);
                                    let teamId = localStorage.getItem("editTeamId");
                                    let objId = localStorage.getItem("editTeamObjId");
                                    this.$store.commit("setStatus", {
                                        type: "editTeamOption",
                                        data: [teamId, objId],
                                    });
                                    let fileKey = key.match(/[^\/]*$/)[0];
                                    this.fileKey = fileKey;
                                    let unloadUrl =
                                        this.urls.apiUrl +
                                        `/api/user/${this.userInfo.user_id}/max/team/${teamId}/obj/${objId}/release/${this.userInfo.token}`;
                                    if (this.isPrivate) {
                                        unloadUrl =
                                            this.urls.apiUrl +
                                            `/api/web/user/${this.userInfo.user_id}/max/team/${teamId}/obj/${fileKey}/release/${this.userInfo.token}`;
                                    }
                                    window.addEventListener("beforeunload", (e) => {
                                        navigator.sendBeacon(unloadUrl);
                                    });
                                    this.$store
                                        .dispatch("downloadTeamFiles", {
                                            obj: key,
                                            teamId,
                                            objId,
                                            file_key: fileKey,
                                        })
                                        .then((data) => {
                                            this.$store.commit("setStatus", {
                                                type: "showLibrary",
                                                data: true,
                                            });
                                            window["_view"].openFromFile(data.data);
                                        })
                                        .catch((err) => {
                                            this.closeLoading();
                                            if (err === "Not allowed") {
                                                (<any>this).$edMessage.warning(this.$t("shareAuthFail"));
                                            } else {
                                                (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                            }
                                            // setTimeout(window.close, 3000)
                                        });
                                } else {
                                    let key = getQueryString(urlData, "obj");
                                    this.trackData(urlData);
                                    this.filterAd(urlData);
                                    this.openClassID = getQueryString(urlData, "classID");
                                    window["_view"].setDocName(docName);
                                    this.setFileID(key).then(() => {
                                        this.addOpenRecord();
                                        this.checkStar();
                                    });
                                    this.$store
                                        .dispatch("downloadFiles", key)
                                        .then((data) => {
                                            this.$store.commit("setStatus", {
                                                type: "showLibrary",
                                                data: true,
                                            });
                                            window["_view"].openFromFile(data.data);
                                        })
                                        .catch((err) => {
                                            this.closeLoading();
                                            (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                            // setTimeout(window.close, 3000)
                                        });
                                }
                            } else if (type === "pre_edit") {
                                urlData += "&file_source=fromNative";
                                this.trackData(urlData);
                                downloadFilePromise
                                    .then((data: any) => {
                                        this.$store.commit("setStatus", {
                                            type: "showLibrary",
                                            data: true,
                                        });
                                        window["_view"].openFromFile(data.data);
                                        this.sensors.track("aiNativeToEdrawMaxCanvaSuccess");
                                    })
                                    .catch((err) => {
                                        this.closeLoading();
                                        (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                    });
                            } else if (type === "create_echart") {
                                urlData += "&file_source=fromNative";
                                this.trackData(urlData);
                                downloadFilePromise
                                    .then((data: any) => {
                                        console.log(data);
                                        this.$store.commit("setStatus", {
                                            type: "showLibrary",
                                            data: true,
                                        });
                                        this.aiEchartData = data[0];
                                        window["_view"].openFromFile(data[1][0]);
                                        this.sensors.track("aiNativeToEdrawMaxCanvaSuccess");
                                    })
                                    .catch((err) => {
                                        this.closeLoading();
                                        (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                    });
                            } else if (type === "seo_link") {
                                downloadFilePromise
                                    .then((data: any) => {
                                        this.$store.commit("setStatus", {
                                            type: "showLibrary",
                                            data: true,
                                        });
                                        const work_id = getQueryString(urlData, "work_id");
                                        let fileName = "";
                                        if (work_id) {
                                            window["_view"].openFromFile(data.data);
                                            const matchResult = (data?.config?.url || "").match(/([^\/.]*)\.eddx/);
                                            fileName = matchResult?.[1] ? decodeURIComponent(matchResult[1]) : "";
                                        } else {
                                            window["_view"].openFromFile(data[0][0]);
                                            fileName = this.$tc("newFile");
                                        }
                                        this.$store.commit("setStatus", {
                                            type: "seoLinkFileName",
                                            data: fileName,
                                        });
                                    })
                                    .catch((err) => {
                                        this.closeLoading();
                                        (<any>this).$edMessage.warning(this.$t("downloadFail"));
                                    });
                            }
                            // else {
                            //     let key= getQueryString(urlData, 'obj');
                            //     let name= getQueryString(urlData, 'name');
                            //     window['_view'].setDocName(name)
                            //     this.$store.dispatch('downloadTem', key).then((data)=>{
                            //         this.$store.commit('setStatus',{
                            //         type: 'showLibrary',
                            //         data: true
                            //         });
                            //         window['_view'].openFromFile(data.data);
                            //     })
                            // }

                            window["_view"].generateCustomVip();
                            window["_view"].generateThemesIcon();
                            window["_view"].generateThemeConnectorsIcon();
                        });

                    let reCustomTheme = false;
                    let userPreferData = null;
                    const getUserPrefer = () => {
                        if (this.noLoginEditor) return Promise.resolve();
                        return this.$store.dispatch("getUserPrefer").then((e) => (userPreferData = e));
                    };
                    const getUserTheme = () => {
                        if (this.noLoginEditor) return Promise.resolve();
                        return this.getUserTheme().then(
                            (e) =>
                                new Promise((resolve) => {
                                    if (e) {
                                        if (e.data) {
                                            ThemeManager.loadCustomTheme(e.data);
                                        }
                                    } else {
                                        // 自定义主题失败。
                                        reCustomTheme = true;
                                    }
                                    resolve();
                                })
                        );
                    };
                    const getConfig = () => {
                        return this.checkConfigFile().then((e) => initEDView());
                    };
                    const loadPreset = () => {
                        return ThemeManager.loadPreset(ts.lang);
                    };
                    const transShapeStr = () => {
                        return LocalizeUtil.translateShapeString();
                    };
                    PromiseArr.push(getUserPrefer(), getUserTheme(), getConfig(), loadPreset(), transShapeStr());

                    Promise.all(PromiseArr).then(() => {
                        let lang = getHashString("lang");
                        const type = getQueryString(urlData, "type");
                        const seoLinkLang = getQueryString(urlData, "lang");
                        if (type === "seo_link" && seoLinkLang) {
                            lang = seoLinkLang;
                        }
                        if (ValidLang.includes(lang)) {
                            this.$store.commit("changeUILang", lang);
                        }
                        if (!this.noLoginEditor) {
                            window["_view"].parseUserPrefer(userPreferData);
                            if (reCustomTheme) {
                                this.getUserTheme().then((data: any) => {
                                    if (data && data.data) {
                                        ThemeManager.loadCustomTheme(data.data);
                                        window["_view"].generateCustomVip();
                                        window["_view"].generateThemesIcon(true);
                                        window["_view"].generateThemeConnectorsIcon(true);
                                    }
                                });
                            }
                        }
                        this.checkSeoTemplateHandler();
                    });
                })
                .catch((err) => {});

            window.addEventListener("resize", this.resizeEchartList);
            this.resizeEchartList();
        }

        backTimer = 0;

        created() {
            this.loading = true;
            if (this.isBoard) {
                let messageHandle = (msg) => {
                    let data = msg.data;
                    if (data.eventName != "boardEvent") return;
                    if (data.action == "newFile") {
                        // let url = location.href.replace(/(plugin\=).[^\&|^\#]*/, '$1'+'board') // 是否需要静态刷新?
                        // history.replaceState(null, document.title, url);
                        location.href = `${window.location.origin}${appConfig["sourcePath"]}`;
                    } else if (data.action == "editFile") {
                        location.href = `${window.location.origin}${appConfig["sourcePath"]}app.html?plugin=boardEdit`;
                    }
                };
                window.addEventListener("message", messageHandle);
            }

            if (window.EDCONFIG.IS_SDK) {
                this.sdkInitEventListener();
            }
            let ts: any = this;
            ts.$bus.$on("relogin", () => {
                ts.checkLog().then((e) => {
                    if (ts.backupUserInfo.user_id != ts.userInfo.user_id) {
                        location.href = location.origin;
                    }
                });
            });
            this.$bus.$on("reloadLibrary", () => {
                this.reloadLibrary();
            });
            this.$bus.$on("showVipPopover", (key) => {
                this.setLocalShowedPopover(key);
            });
            let receiveMessage = (event) => {
                if (event.origin !== location.origin) return;
                if (event.data.type && event.data.type == "updateMyfile") {
                    if (event.data.updateStarFile) {
                        this.checkStar();
                    }
                } else if (event.data.type && event.data.type == "useStoreSymbol") {
                    console.log("useStoreSymbol", event.data);
                    this.openLibraryWorkID = event.data.obj.openLibraryWorkID;
                    this.openLibraryID = event.data.obj.table_id;
                    console.log(this.openLibraryID, this.openLibraryWorkID);
                    this.getLibraryList(true).then((e: any) => {
                        let targetTableName = event.data.obj.obj.match(/[^\/]*(?=\.edt)/i)[0],
                            targetTableID = 0;
                        let tempCheckbox = JSON.parse(JSON.stringify(this.checkbox));
                        for (let i = 0; i < this.menuList.length; i++) {
                            if (this.menuList[i].id == 66666) {
                                let child = this.menuList[i].children;
                                for (let j = 0; j < child.length; j++) {
                                    if (child[j].tableName == targetTableName) {
                                        targetTableID = child[j].id;
                                        tempCheckbox[this.menuList[i]["groupName"]].push(targetTableID);
                                        break;
                                    }
                                }
                            }
                        }
                        console.log(tempCheckbox);
                        this.checkbox = tempCheckbox;
                        this.$bus.$emit("useStoreSymbolExpand", targetTableID);
                    });
                } else if (event.data?.type == "skullTrack") {
                    let obj =
                        event.data.event == "showBtn"
                            ? {
                                  Catalogues: "downloadEdrawmaxTips",
                                  popup_source: "loadingPage",
                              }
                            : {
                                  Catalogues: "downloadEdrawmaxTips",
                                  click_source: "loadingPage",
                              };
                    let trackName = event.data.event == "showBtn" ? "downloadTips_popup" : "downloadTips_click";
                    console.log(trackName, obj);
                    this.sensors.track(trackName, obj);
                }
            };

            this.$bus.$on("loadLibraryByTableId", async (obj: any) => {
                let { payload, resolve, reject } = obj;
                let { tableId } = payload;
                let data = await this.loadLibraryByTableId(tableId);
                resolve(data);
            });

            window.addEventListener("message", receiveMessage, false);
            // window.addEventListener("beforeunload", this.removeStore);

            if (location.search == "") {
                this.backTimer = setTimeout(() => {
                    location.href = `${location.origin}/online/`;
                }, 20000);
            }

            if (appConfig.isBuild && !this.isPlugin && !this.isTeamsApp && window.EDCONFIG.UNSAVED_BLOCK_CLOSE_ENABLE !== false) {
                window.addEventListener("beforeunload", (e) => {
                    let leaveMsg = "";
                    if (AutoSaveTimer) {
                        e.preventDefault();
                        e.returnValue = leaveMsg;
                        return leaveMsg;
                    }
                });
            }

            this.$bus.$on("canvasOnsize", () => {
                this.$nextTick(() => {
                    this.getCanvasSize();
                });
            });

            this.$bus.$on("sdkRefreshFile", () => {
                this.refreshFile();
            });
        }

        beforeDestory() {
            // window.removeEventListener("beforeunload", this.removeStore);
            window.removeEventListener("resize", this.resizeEchartList);
        }

        //*** output xml for pc */
        // outputXML(){
        //     let keys = {
        //         gs : 'Galleries',
        //         g : 'Gallery',
        //         ts : 'Templates',
        //         t : 'Template',
        //         nu : 'NameU',
        //         n : 'Name',
        //         the : 'Theme',
        //         i : 'Icon',
        //         d : 'Description',
        //         v: 'Version'
        //     },
        //         params = {tempInfo: "templatecls"},
        //         lang = 'en';
        //     this.$edApi.getTemplateInfo(params).then(res => {
        //         let data = res.data.data;
        //         console.log(data)
        //         let hasXmlDom: boolean = document.implementation.hasFeature('XML', '2.0');
        //         hasXmlDom = hasXmlDom && typeof XMLSerializer != 'undefined';
        //         let xmlDoc: XMLDocument = EDDocument._genXmlDom(hasXmlDom, keys.gs);
        //         if (!xmlDoc) return null;
        //         let templateNode = xmlDoc.documentElement;
        //         if (!templateNode) return;
        //         templateNode.setAttribute('Default', data[0].class.name);

        //         let addGallery = (data) => {
        //             let galleryData = data.class;
        //             let itemsNode = xmlDoc.createElement(keys.g);
        //             itemsNode.setAttribute(keys.nu, galleryData.name);
        //             itemsNode.setAttribute(keys.n, lang == 'en' ? galleryData.name : galleryData[`name_${lang}`]);
        //             itemsNode.setAttribute(keys.v, '1.0');
        //             itemsNode.setAttribute(keys.d, lang == 'en' ? galleryData.description : galleryData[`desc_${lang}`]);
        //             templateNode.appendChild(itemsNode);
        //             if(data.subclass.length > 0){
        //                 for(let i = 0; i < data.subclass.length; i++){
        //                     addTemplates(itemsNode, data.subclass[i])
        //                 }
        //             }
        //         }
        //         let addTemplates = (parent, templatesData) => {    //   theme   icon
        //             let itemsNode = xmlDoc.createElement(keys.ts);
        //             itemsNode.setAttribute(keys.nu, templatesData.name);
        //             itemsNode.setAttribute(keys.n, lang == 'en' ? templatesData.name : templatesData[`name_${lang}`]);
        //             itemsNode.setAttribute(keys.d, lang == 'en' ? templatesData.description : templatesData[`desc_${lang}`]);
        //             parent.appendChild(itemsNode);
        //         }
        //         for(let i = 0; i < data.length; i++){
        //             addGallery(data[i]);
        //         }
        //         let itemsNode = xmlDoc.createElement(keys.g);
        //         templateNode.appendChild(itemsNode);

        //         let contentEdt = "<?xml version=\"1.0\" encoding=\"utf-8\"?>" + (new XMLSerializer).serializeToString(xmlDoc);
        //         saveAs(new Blob([contentEdt], { type: "text/xml" }), 'xxx.xml')
        //     })
        // }
    }
</script>
<i18n>
{
  "zh": {
    "netError": "网络错误，请检查网络",
    "downloadFail": "下载文件失败, 3秒后自动关闭窗口",
    "creatFileFail": "创建文件失败",
    "shareAuthFail": "获取文件编辑权限失败，请从分享页面重新进入",
    "shareCancel": "分享已取消",
    "uuidError": "未获取到分享文件信息，请从分享页面重新进入，打开前请勿关闭分享页面",
    "filenumlimitTips": "非会员仅可编辑最近创建的{fileNum}个云文件（且文件未使用VIP特权），其余的仅供查看，<b>开通VIP尊享无限编辑文件</b>",
    "reject-tips": "审核未通过的原因可以在 “账号中心>消息中心” 查看<br>编辑完成点击右上角发布，作品即可在社区更新~",
    "noreject-tips": "编辑完成点击右上角发布，作品即可在社区更新~",
    "fileDeleted": "该文件已删除~",
    "fileRenamed": "文件已被重命名，返回刷新重新打开~",
    "newFile": "未命名文件"
  },
  "en": {
    "netError": "Network error, please check the network.",
    "downloadFail": "Fail to download file, this window will close automatically after 3 seconds.",
    "creatFileFail": "Fail to create new file.",
    "shareAuthFail": "Fail to get authority to edit file, reenter from share page plz",
    "shareCancel": "Sharing canceled",
    "uuidError": "Fail to get share file info, reenter from share page, keep the share page before open file",
    "filenumlimitTips": "Non-premiums can only edit the {fileNum} most recently created cloud files (provided that Premium benefits were not used for these files). Other files are view-only.<b>Upgrade to Premium for unlimited editing.</b>",
    "reject-tips": "You can view the reasons approval was denied in My Account > Messages.<br>Click Publish after finishing editing, to update your work in the community.",
    "noreject-tips": "Click Publish after finishing editing, to update your work in the community.",
    "fileDeleted": "File deleted~",
    "fileRenamed": "File Renamed~",
    "newFile": "Unnamed File"
  },
  "jp": {
    "netError": "ネットワークエラー、ネットワークを確認してください。",
    "downloadFail": "ファイルのダウンロードに失敗しました。3秒後にウィンドウが自動的に閉じ られます",
    "creatFileFail": "ファイルの作成に失敗しました",
    "shareAuthFail": "ファイルの編集権限を取得できませんでした。共有ページから再度ファイルを開いてみてください。",
    "shareCancel": "共有がキャンセルされました",
    "uuidError": "共有ファイルの情報を取得できませんでした。共有ページから再度ファイルを開いてみてください。ファイルを開く前に共有ページを閉じないでください。",
    "filenumlimitTips": "無料版ユーザーは、直近に作成した{fileNum}つのクラウドファイルのみ編集できます（プレミアム特典がそのファイルに使用されていない場合）。他のファイルは表示のみ可能です。<b>無制限の編集を得るには、プレミアムにアップグレードしてください</b>"
  },
  "de": {
    "netError": "Netzwerkfehler, bitte überprüfen Sie das Netzwerk",
    "downloadFail": "Fehler beim Herunterladen der Datei, dieses Fenster wird nach 3 Sekunden automatisch geschlossen",
    "creatFileFail": "Neue Datei kann nicht erstellt werden",
    "shareAuthFail": "Wenn Sie keine Berechtigung zum Bearbeiten von Dateien erhalten haben, geben Sie diese erneut auf der Freigabeseite ein",
    "shareCancel": "Freigabe abgebrochen",
    "uuidError": "Die Informationen zur freigegebenen Datei werden nicht abgerufen. Geben Sie sie erneut auf der Freigabeseite ein. Schließen Sie die Freigabeseite nicht vor dem Öffnen",
    "filenumlimitTips": "Benutzer der kostenlosen Version können nur die {fileNum} zuletzt erstellten Cloud-Dateien bearbeiten (vorausgesetzt, dass für diese Dateien keine Premium-Vorteile verwendet wurden). Andere Dateien sind schreibgeschützt. <b>Führen Sie ein Upgrade auf Premium durch, um Bearbeitungen ohne Einschränkungen zu erhalten.</b>"
  },
  "fr": {
    "netError": "Erreur réseau, veuillez vérifier le réseau.",
    "downloadFail": "Défaut de télécharger le fichier, cette fenêtre se fermera automatiquement après 3 secondes.",
    "creatFileFail": "Défaut de créer un nouveau fichier.",
    "shareAuthFail": "Échec de l'obtention de l'autorisation de modification de fichier, veuillez le saisir à nouveau à partir de la page de partage",
    "shareCancel": "Partage annulé",
    "uuidError": "Les informations du fichier partagé ne sont pas obtenues, veuillez les saisir à nouveau à partir de la page de partage, veuillez ne pas fermer la page de partage avant de l'ouvrir",
    "filenumlimitTips": "Les utilisateurs de la version gratuite peuvent uniquement modifier les {fileNum} derniers fichiers créés sur le cloud (si les avantages Premium n'ont pas été utilisés pour ces fichiers). Les autres fichiers sont en lecture seule. <b>Passez à la version Premium pour une édition illimitée.</b>"
  },
  "es": {
    "netError": "Error de red, por favor compruebe la red",
    "downloadFail": "Si no se descarga el archivo, esta ventana se cerrará automáticamente después de 3 segundos",
    "creatFileFail": "Falla en la creación de un nuevo archivo",
    "shareAuthFail": "\nFalla en obtener la autoridad para editar el archivo，volver a entrar desde la página para compartir por favor",
    "shareCancel": "Compartir cancelado",
    "uuidError": "Falla en obtener la información del archivo compartido, vuelva a ingresar desde la página para compartir, mantenga la página para compartir antes de abrir el archivo\n",
    "filenumlimitTips": "Los usuarios de la versión gratuita solo pueden editar los {fileNum} archivos en la nube creados más recientemente (siempre que no se hayan usado las ventajas Premium en estos archivos). El resto de archivos serán solo para su visualización. <b>Actualice a Premium para editar de forma ilimitada.</b>"
  },
  "pt": {
    "netError": "Erro de Rede, por favor, verificar a rede.",
    "downloadFail": "Falha ao descarregar o ficheiro, esta janela irá fechar automaticamente após 3 segundos.",
    "creatFileFail": "Falha ao criar novo ficheiro.",
    "shareAuthFail": "Falha ao obter autoridade para editar o arquivo, insira novamente na página de compartilhamento, por favor",
    "shareCancel": "Compartilhamento cancelado",
    "uuidError": "Falha ao obter informações do arquivo de compartilhamento, reinsira na página de compartilhamento, mantenha a página de compartilhamento antes de abrir o arquivo",
    "filenumlimitTips": "Usuários não premium podem editar apenas os {fileNum} arquivos de nuvem criados mais recentemente (desde que os benefícios Premium não tenham sido usados para esses arquivos). Os demais arquivos são somente exibição. <b>Atualize para a versão Premium para editar sem limites.</b>"
  },
  "it": {
    "netError": "Errore di rete. Si prega di controllare lo stato della connessione.",
    "downloadFail": "Impossibile eseguire il download. Questa finestra si chiuderà automaticamente tra 3 secondi.",
    "creatFileFail": "Impossibile creare il nuovo file.",
    "shareAuthFail": "Impossibile ottenere l'autorizzazione per modificare il file, reinseriscilo dalla pagina di condivisione",
    "shareCancel": "Condivisione annullata",
    "uuidError": "Le informazioni sul file condiviso non sono state ottenute, reinserirle dalla pagina di condivisione, non chiudere la pagina di condivisione prima di aprirla",
    "filenumlimitTips": "Gli utenti che non dispongono della versione Premium possono modificare solo i {fileNum} file su cloud creati più di recente (purché non abbiano utilizzato i vantaggi Premium per tali file). Gli altri file sono disponibili per la sola visualizzazione. <b>Passa alla versione Premium per modifiche illimitate</b>"
  },
  "tw": {
    "netError": "網絡錯誤，請檢查網絡",
    "downloadFail": "下載檔案失敗, 3秒後自動關閉窗口",
    "creatFileFail": "建立檔案失敗",
    "shareAuthFail": "獲取檔案編輯權限失敗，請從分享頁面重新進入",
    "shareCancel": "分享已取消",
    "uuidError": "未獲取到分享檔案信息，請從分享頁面重新進入，打開前請勿關閉分享頁面",
    "filenumlimitTips": "非 Premium 權益使用者只能編輯 {fileNum} 個最近建立的雲端檔案 (前提是 Premium 權益未使用於這些檔案)。其他檔案僅供檢視。<b>升級至 Premium 以享有無限編輯權限。</b>"
  },
  "kr": {
    "netError": "네트워크 오류입니다. 네트워크를 확인하십시오.",
    "downloadFail": "파일을 다운로드하지 못했습니다. 이 창은 3초 후에 자동으로 닫힙니다.",
    "creatFileFail": "새 파일 생성 실패",
    "shareAuthFail": "파일 편집 권한을 가져오지 못했습니다. 공유 페이지에서 다시 입력하십시오.",
    "shareCancel": "공유가 취소됨",
    "uuidError": "공유 파일 정보를 가져오지 못했습니다. 공유 페이지에서 다시 입력하고 파일을 열기 전에 공유 페이지를 유지하십시오.",
    "filenumlimitTips": "무료 버전 사용자는 가장 최근에 생성된 {fileNum}개의 클라우드 파일만 편집할 수 있습니다(단, 이 파일에 프리미엄 혜택을 사용하지 않은 경우). 다른 파일은 보기 전용입니다. <b>프리미엄으로 업그레이드하여 무제한 편집을 이용하십시오.</b>"
  }
}
</i18n>
